(() => {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5IiZx", function(module, exports) {
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("cyZaJ", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("dNLwc"))($parcel$resolve("lzS4w")),
    (parcelRequire("dNLwc"))($parcel$resolve("598Sc"))
]).then(()=>parcelRequire('bHC7U'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("emPjJ", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("dNLwc"))($parcel$resolve("lzS4w")),
    (parcelRequire("dNLwc"))($parcel$resolve("6r6ey"))
]).then(()=>parcelRequire('jnkyK'));

});

parcelRegister("7sJ6e", function(module, exports) {

$parcel$export(module.exports, "disableBodyScroll", () => $56ee21bb486a2ccd$export$24fdf68abf432c44);
$parcel$export(module.exports, "enableBodyScroll", () => $56ee21bb486a2ccd$export$e5d0524c3725571e);
function $56ee21bb486a2ccd$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $56ee21bb486a2ccd$var$hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var $56ee21bb486a2ccd$var$passiveTestOptions = {
        get passive () {
            $56ee21bb486a2ccd$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, $56ee21bb486a2ccd$var$passiveTestOptions);
    window.removeEventListener('testPassive', null, $56ee21bb486a2ccd$var$passiveTestOptions);
}
var $56ee21bb486a2ccd$var$isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var $56ee21bb486a2ccd$var$locks = [];
var $56ee21bb486a2ccd$var$documentListenerAdded = false;
var $56ee21bb486a2ccd$var$initialClientY = -1;
var $56ee21bb486a2ccd$var$previousBodyOverflowSetting = void 0;
var $56ee21bb486a2ccd$var$previousBodyPosition = void 0;
var $56ee21bb486a2ccd$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $56ee21bb486a2ccd$var$allowTouchMove = function allowTouchMove(el) {
    return $56ee21bb486a2ccd$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $56ee21bb486a2ccd$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($56ee21bb486a2ccd$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $56ee21bb486a2ccd$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($56ee21bb486a2ccd$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
            $56ee21bb486a2ccd$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($56ee21bb486a2ccd$var$previousBodyOverflowSetting === undefined) {
        $56ee21bb486a2ccd$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var $56ee21bb486a2ccd$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($56ee21bb486a2ccd$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $56ee21bb486a2ccd$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $56ee21bb486a2ccd$var$previousBodyPaddingRight = undefined;
    }
    if ($56ee21bb486a2ccd$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $56ee21bb486a2ccd$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $56ee21bb486a2ccd$var$previousBodyOverflowSetting = undefined;
    }
};
var $56ee21bb486a2ccd$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($56ee21bb486a2ccd$var$previousBodyPosition === undefined) {
            $56ee21bb486a2ccd$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = 'fixed';
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $56ee21bb486a2ccd$var$restorePositionSetting = function restorePositionSetting() {
    if ($56ee21bb486a2ccd$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $56ee21bb486a2ccd$var$previousBodyPosition.position;
        document.body.style.top = $56ee21bb486a2ccd$var$previousBodyPosition.top;
        document.body.style.left = $56ee21bb486a2ccd$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $56ee21bb486a2ccd$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $56ee21bb486a2ccd$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $56ee21bb486a2ccd$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $56ee21bb486a2ccd$var$initialClientY;
    if ($56ee21bb486a2ccd$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $56ee21bb486a2ccd$var$preventDefault(event);
    if ($56ee21bb486a2ccd$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $56ee21bb486a2ccd$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $56ee21bb486a2ccd$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($56ee21bb486a2ccd$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $56ee21bb486a2ccd$var$locks = [].concat($56ee21bb486a2ccd$var$_toConsumableArray($56ee21bb486a2ccd$var$locks), [
        lock
    ]);
    if ($56ee21bb486a2ccd$var$isIosDevice) $56ee21bb486a2ccd$var$setPositionFixed();
    else $56ee21bb486a2ccd$var$setOverflowHidden(options);
    if ($56ee21bb486a2ccd$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $56ee21bb486a2ccd$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $56ee21bb486a2ccd$var$handleScroll(event, targetElement);
        };
        if (!$56ee21bb486a2ccd$var$documentListenerAdded) {
            document.addEventListener('touchmove', $56ee21bb486a2ccd$var$preventDefault, $56ee21bb486a2ccd$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $56ee21bb486a2ccd$var$documentListenerAdded = true;
        }
    }
};
var $56ee21bb486a2ccd$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($56ee21bb486a2ccd$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $56ee21bb486a2ccd$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($56ee21bb486a2ccd$var$documentListenerAdded) {
            document.removeEventListener('touchmove', $56ee21bb486a2ccd$var$preventDefault, $56ee21bb486a2ccd$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $56ee21bb486a2ccd$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $56ee21bb486a2ccd$var$initialClientY = -1;
    }
    if ($56ee21bb486a2ccd$var$isIosDevice) $56ee21bb486a2ccd$var$restorePositionSetting();
    else $56ee21bb486a2ccd$var$restoreOverflowSetting();
    $56ee21bb486a2ccd$var$locks = [];
};
var $56ee21bb486a2ccd$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    $56ee21bb486a2ccd$var$locks = $56ee21bb486a2ccd$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($56ee21bb486a2ccd$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($56ee21bb486a2ccd$var$documentListenerAdded && $56ee21bb486a2ccd$var$locks.length === 0) {
            document.removeEventListener('touchmove', $56ee21bb486a2ccd$var$preventDefault, $56ee21bb486a2ccd$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $56ee21bb486a2ccd$var$documentListenerAdded = false;
        }
    }
    if ($56ee21bb486a2ccd$var$isIosDevice) $56ee21bb486a2ccd$var$restorePositionSetting();
    else $56ee21bb486a2ccd$var$restoreOverflowSetting();
};

});

var $48c7c58366e89807$exports = {};
$parcel$extendImportMap({
    "598Sc": "donate.060d5489.js",
    "lzS4w": "donate.e742bdef.js",
    "6r6ey": "one-click-buy.a821ca8c.js"
});

/**
 * navigation.js
 *
 * Handles toggling the navigation menu for small screens.
 */ jQuery(function($) {
    var container = document.getElementById('site-navigation'), button = container.getElementsByTagName('button')[0], menu = container.getElementsByTagName('ul')[0], html = document.getElementsByTagName('html')[0];
    if (undefined == button || undefined == menu) return false;
    button.onclick = function() {
        if (html.classList.contains('no-scroll')) html.classList.remove('no-scroll');
        else html.classList.add('no-scroll');
        if (-1 == menu.className.indexOf('nav-menu')) menu.className = 'nav-menu';
        if (-1 != button.className.indexOf('toggled-on')) {
            button.className = button.className.replace(' toggled-on', '');
            menu.className = menu.className.replace(' toggled-on', '');
            container.className = container.className.replace('main-small-navigation', 'main-navigation');
        } else {
            button.className += ' toggled-on';
            menu.className += ' toggled-on';
            container.className = container.className.replace('main-navigation', 'main-small-navigation');
        }
    };
    // 2023 Updates
    // add aria-expanded to menu items with children
    $('.menu-item-has-children > a').attr('aria-expanded', 'false');
    $('.menu-item-has-children > a').hover(function() {
        $(this).attr('aria-expanded', 'true');
    }, function() {
        $(this).attr('aria-expanded', 'false');
    });
    // add aria-label to nav items contain 'PuSh'
    $('#site-navigation .menu-item-has-children:first ul.sub-menu li a').each(function() {
        if ($(this).html().indexOf('PuSh') >= 0) {
            var push = $(this).html().replace('PuSh', '<span aria-label="Push">PuSh</span>');
            $(this).html(push);
        }
    });
    // keyboard accessibility
    $('#site-navigation .menu-item-has-children').keydown(function(e) {
        if (e.key === ' ' || e.key === 'Enter' || e.key === 'ArrowDown') {
            e.preventDefault();
            $(this).children('a').attr('aria-expanded', 'true');
            $(this).children('ul').show();
            $(this).children('ul').find('a').first().focus();
        }
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            $(this).children('a').attr('aria-expanded', 'false');
            $(this).children('ul').hide();
            if ($(this).prev().length === 0) $(this).parent().children('li:last-child').children('a').focus();
            else $(this).prev().children('a').focus();
        }
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            $(this).children('a').attr('aria-expanded', 'false');
            $(this).children('ul').hide();
            if ($(this).next().length === 0) $(this).parent().children('li:first-child').children('a').focus();
            else $(this).next().children('a').focus();
        }
    });
    $('#site-navigation .menu-item ul.sub-menu li a').keydown(function(e) {
        if (e.key === 'Enter') {
            e.stopPropagation();
            $(this).click();
        }
        if (e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            // click is not working
            window.location.href = $(this).attr('href');
        }
        if (e.key === 'Escape') {
            e.preventDefault();
            $(this).parent().parent().hide();
            $(this).parent().parent().siblings('a').attr('aria-expanded', 'false');
            $(this).parent().parent().siblings('a').focus();
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            if ($(this).parent().prev().length === 0) $(this).parent().siblings('li').last().children('a').focus();
            else $(this).parent().prev().children('a').focus();
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            e.stopPropagation(); // Prevent event from bubbling up to parent
            if ($(this).parent().next().length === 0) $(this).parent().siblings('li').first().children('a').focus();
            else $(this).parent().next().children('a').focus();
        }
    });
    $('#site-navigation .menu-item ul.sub-menu li:last-child a').keydown(function(e) {
        if (e.key === 'Tab') {
            $(this).parent().parent().hide();
            $(this).parent().parent().siblings('a').attr('aria-expanded', 'false');
        }
    });
    // Desktop dropdowns: one highlight per menu, the sub-menu's ::before
    // (sass/header/_navigation.scss). It glides to the hovered or focused item
    // and, when the pointer leaves, rests on the current page's item or
    // hides. Taps don't move it, and the phone menu doesn't have it.
    var desktop = window.matchMedia('(min-width: 768px)');
    $('#site-navigation .menu > li > .sub-menu').each(function() {
        var sub = this, parent = sub.parentElement, current = sub.querySelector(':scope > li.current-menu-item > a:not([href*="#"])'), hovered = null;
        sub.classList.add('has-highlight');
        // Returns false when the menu isn't laid out (closed).
        function place(link) {
            if (!link) {
                sub.classList.remove('highlight-on');
                return true;
            }
            var h = link.offsetHeight;
            if (!h) return false;
            sub.style.setProperty('--highlight-y', link.offsetTop + 'px');
            sub.style.setProperty('--highlight-h', h + 'px');
            sub.classList.add('highlight-on');
            return true;
        }
        function rest() {
            if (!desktop.matches) return;
            var focused = sub.contains(document.activeElement) && document.activeElement.tagName === 'A' ? document.activeElement : null;
            var target = hovered || focused || current;
            if (!place(target)) // Opening on a tap can lay the menu out a frame later.
            requestAnimationFrame(function() {
                place(target);
            });
        }
        parent.addEventListener('pointerover', function(e) {
            if (!desktop.matches) return;
            var item = e.target.closest('li');
            if (item && item.parentElement === sub) {
                if (e.pointerType === 'touch') return;
                hovered = item.querySelector('a');
                place(hovered);
            } else if (!sub.contains(e.target)) // On the section's own link: the menu is opening (or the
            // pointer came back up from it).
            rest();
        });
        parent.addEventListener('pointerenter', function() {
            // The key handlers above close a menu with an inline display: none,
            // which would stop hover opening it again.
            if (sub.style.display === 'none') sub.style.display = '';
        });
        sub.addEventListener('pointerleave', function() {
            hovered = null;
            rest();
        });
        sub.addEventListener('focusin', function(e) {
            if (desktop.matches && e.target.tagName === 'A') place(e.target);
        });
        sub.addEventListener('focusout', function() {
            setTimeout(function() {
                if (!sub.contains(document.activeElement)) rest();
            });
        });
    });
    $('#site-navigation .current_page_item').click(function() {
        $(html).removeClass('no-scroll');
        $(button).removeClass('toggled-on');
        $(menu).removeClass('toggled-on');
        $(container).removeClass('main-small-navigation').addClass('main-navigation');
    });
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 568 && -1 != button.className.indexOf('toggled-on')) {
            button.className = button.className.replace(' toggled-on', '');
            menu.className = menu.className.replace(' toggled-on', '');
            container.className = container.className.replace('main-small-navigation', 'main-navigation');
        }
        if (window.innerWidth >= 568) document.getElementsByTagName('html')[0].classList.remove('no-scroll');
    });
    // Hide menu toggle button if menu is empty.
    if (!menu.childNodes.length) button.style.display = 'none';
});


const $b509ddf314135525$var$EXPAND_HEIGHT = 450;
// The clamped region's scrollHeight stays large once it has overflowed, and
// a multi-column box can report its single-column height. The columns
// element's border box is the height on screen.
function $b509ddf314135525$var$contentHeight(region) {
    const columns = region.querySelector(".extra-details-columns");
    return columns ? columns.offsetHeight : region.scrollHeight;
}
function $b509ddf314135525$var$bindExpand(region) {
    if (region.dataset.expandReady === "true") return;
    const button = region.nextElementSibling;
    if (!(button instanceof HTMLButtonElement)) return;
    region.dataset.expandReady = "true";
    button.style.display = "none";
    let expanded = false;
    const update = ()=>{
        if (expanded) return;
        const tall = $b509ddf314135525$var$contentHeight(region) > $b509ddf314135525$var$EXPAND_HEIGHT;
        region.classList.toggle("is-shortened", tall);
        button.style.display = tall ? "" : "none";
        if (tall) {
            button.removeAttribute("aria-hidden");
            button.removeAttribute("tabindex");
        } else {
            button.setAttribute("aria-hidden", "true");
            button.setAttribute("tabindex", "-1");
        }
    };
    update();
    requestAnimationFrame(update);
    // Images and the webfont change the height after the first measure.
    setTimeout(update, 100);
    if (document.fonts) document.fonts.ready.then(update);
    const measured = region.querySelector(".extra-details-columns") ?? region;
    if (typeof ResizeObserver !== "undefined") new ResizeObserver(update).observe(measured);
    button.addEventListener("click", ()=>{
        expanded = true;
        region.classList.remove("is-shortened");
        button.style.display = "none";
        button.setAttribute("aria-hidden", "true");
        button.setAttribute("tabindex", "-1");
    });
}
function $b509ddf314135525$export$62d0a7dd8cddd947(root = document) {
    if (root instanceof Element && root.matches(".artist-bio, .extra-details")) $b509ddf314135525$var$bindExpand(root);
    root.querySelectorAll(".artist-bio, .extra-details").forEach($b509ddf314135525$var$bindExpand);
}
function $b509ddf314135525$var$watchForInserted() {
    new MutationObserver((records)=>{
        records.forEach((record)=>{
            record.addedNodes.forEach((node)=>{
                if (node instanceof Element) $b509ddf314135525$export$62d0a7dd8cddd947(node);
            });
        });
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
}
$b509ddf314135525$export$62d0a7dd8cddd947();
if (document.body) $b509ddf314135525$var$watchForInserted();
else document.addEventListener("DOMContentLoaded", $b509ddf314135525$var$watchForInserted);



$af49fad83e3a47d5$export$226c1dc98323ee4d();
function $af49fad83e3a47d5$export$226c1dc98323ee4d() {
    jQuery(function($) {
        // ACCORDIONS
        $(".accordion").on("click", function() {
            var $section = $(this).parent(".tab-content");
            var accordionTarget;
            if ($section.length > 0) accordionTarget = $section.children('div[data-id="' + $(this).data("target") + '"]').first();
            else accordionTarget = $('div[data-id="' + $(this).data("target") + '"]').first();
            // The chevron (.dropdown-icon) turns over in CSS on .active; see
            // components/_accordion.scss.
            if ($(this).hasClass("active")) {
                $(this).removeClass("active").attr("aria-expanded", false);
                $(accordionTarget).slideUp("fast");
            } else {
                $(this).addClass("active").attr("aria-expanded", true);
                $(accordionTarget).slideDown("fast");
            }
            (0, $6e19b39be3a165d4$export$99f06dcbfd164329)($(this).data("target"));
            return false;
        });
        // ACCORDIONS keyboard support
        $(".accordion").on("keydown", function(e) {
            if (e.key === "Enter" || e.key === " ") $(this).click();
            if (e.key === "Tab" && e.shiftKey) {
                e.preventDefault();
                $(this).prevAll(".accordion").first().focus();
                if ($(this).prevAll(".accordion").length === 0) $(this).parent().find("a, button").first().focus();
            }
            // accordion in tab
            if ($(this).parent().hasClass("tab-content")) {
                if ($(this).nextAll(".accordion").length === 0 && e.key === "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    $("main").next().find("a, button").first().focus();
                }
                if ($(this).prevAll(".accordion").length === 0 && e.key === "Tab" && e.shiftKey) {
                    e.preventDefault();
                    $(this).parent().siblings(".tab.active").focus();
                }
            }
        });
    });
}


// LocalStorage cache with 20-minute expiration
const $691f61a55cf389ac$var$CACHE_KEY_PREFIX = "modalCache_3_";
const $691f61a55cf389ac$var$CACHE_TTL_MS = 1200000; // 20 minutes
function $691f61a55cf389ac$var$getCachedContent(url) {
    const key = $691f61a55cf389ac$var$CACHE_KEY_PREFIX + url;
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    try {
        const entry = JSON.parse(stored);
        if (Date.now() - entry.timestamp < $691f61a55cf389ac$var$CACHE_TTL_MS) return entry.content;
        // Expired, remove it
        localStorage.removeItem(key);
    } catch  {
        localStorage.removeItem(key);
    }
    return null;
}
function $691f61a55cf389ac$var$setCachedContent(url, content) {
    const key = $691f61a55cf389ac$var$CACHE_KEY_PREFIX + url;
    const entry = {
        content: content,
        timestamp: Date.now()
    };
    try {
        localStorage.setItem(key, JSON.stringify(entry));
    } catch  {
    // localStorage full or unavailable, ignore
    }
}
function $691f61a55cf389ac$var$initShowModal() {
    // The service owns show dialogs when its theme bridge is configured.
    if (window.ShortlistConfig?.site === "push") return;
    const modal = document.getElementById("show-modal");
    if (!modal) return;
    const modalContent = modal.querySelector(".show-modal-content");
    function preloadContent(url) {
        if (!$691f61a55cf389ac$var$getCachedContent(url)) {
            updateActions(true);
            fetch(`${url}?bare=1`).then((response)=>response.text()).then((data)=>{
                $691f61a55cf389ac$var$setCachedContent(url, data);
            }).catch(()=>{
            // Don't cache errors
            });
        }
    }
    function updateActions(isActive, currentShowIndex, totalShows) {
        const prevButton = modal.querySelector(".button-prev");
        const nextButton = modal.querySelector(".button-next");
        if (prevButton && nextButton) {
            if (isActive) {
                prevButton.setAttribute("disabled", "true");
                nextButton.setAttribute("disabled", "true");
            } else {
                if (currentShowIndex === 0) prevButton.setAttribute("disabled", "true");
                else prevButton.removeAttribute("disabled");
                if (currentShowIndex === totalShows - 1) nextButton.setAttribute("disabled", "true");
                else nextButton.removeAttribute("disabled");
            }
        }
    }
    function openModal(event) {
        // const isMobile = window.matchMedia("(max-width: 1024px)").matches;
        const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
        const link = event.target.closest("a[data-modal-url]");
        const isToday = link?.getAttribute("data-today") === "true";
        const modalDay = link?.getAttribute("data-modal-day");
        const linkHash = link?.hash || "";
        // add loading class to modal
        modal.classList.add("loading");
        let currentUrl = link?.getAttribute("data-modal-url") || "";
        modal.setAttribute("data-current-url", currentUrl);
        updateUrl(currentUrl.replace(window.location.origin, ""));
        resetButtons();
        modal.showModal();
        const availableModalLinks = document.querySelectorAll(isToday ? "#today a[data-modal-url]" : modalDay ? `.program-daily-day#${CSS.escape(modalDay)} h4 a[data-modal-url]` : ".show-list-item:not(.show-list-item--ad):not(.show-list-item--hidden) a[data-modal-url]");
        const currentShowIndex = Array.from(availableModalLinks).findIndex((link)=>link.getAttribute("data-modal-url") === currentUrl);
        // Trigger reflow before adding class to ensure transition works
        modal.offsetHeight;
        modal.classList.add("visible");
        document.documentElement.style.overflow = "hidden";
        const setModalContent = (data)=>{
            modal.classList.remove("loading");
            if (modal.getAttribute("data-current-url") === currentUrl) {
                modalContent.innerHTML = data;
                (0, $af49fad83e3a47d5$export$226c1dc98323ee4d)();
                initAnchors();
                (0, $b509ddf314135525$export$62d0a7dd8cddd947)(modalContent);
                // Initialize spektrix forms in modal content
                if (typeof window.initSpektrixForms === 'function') window.initSpektrixForms(modalContent);
                if (linkHash) requestAnimationFrame(()=>scrollToHash(linkHash));
            }
        };
        const cachedContent = $691f61a55cf389ac$var$getCachedContent(currentUrl);
        if (cachedContent) setModalContent(cachedContent);
        else fetch(`${currentUrl}?bare=1`).then((response)=>response.text()).then((data)=>{
            $691f61a55cf389ac$var$setCachedContent(currentUrl, data);
            setModalContent(data);
        }).catch(()=>{
            modalContent.innerHTML = "<p>Error loading content. Please try again.</p>";
        });
        updateActions(false, currentShowIndex, availableModalLinks.length);
        // Close button
        const closeButton = modal.querySelector(".button-close");
        closeButton.focus();
        closeButton.addEventListener("click", closeModal);
        modal.addEventListener("keydown", handleEscapeKey);
        modal.addEventListener("click", (event)=>{
            if (event.target === modal) closeModal();
        });
        // New tab button
        const newTabButton = modal.querySelector(".button-tab");
        newTabButton.addEventListener("click", ()=>{
            window.open(link?.href || currentUrl, "_blank");
        });
        // Prev and next buttons
        const prevButton = modal.querySelector(".button-prev");
        const nextButton = modal.querySelector(".button-next");
        const hideControllers = link?.getAttribute("data-modal-controllers") === "false" || availableModalLinks.length < 2;
        if (hideControllers) {
            prevButton.style.display = "none";
            nextButton.style.display = "none";
        } else {
            prevButton.style.display = "flex";
            nextButton.style.display = "flex";
            if (prevButton && nextButton) {
                const prevShow = currentShowIndex > 0 ? availableModalLinks[currentShowIndex - 1] : null;
                const nextShow = currentShowIndex < availableModalLinks.length - 1 ? availableModalLinks[currentShowIndex + 1] : null;
                prevButton.addEventListener("click", ()=>{
                    if (prevShow) {
                        modalContent.innerHTML = "";
                        prevShow.click();
                        updateActions(false, currentShowIndex - 1, availableModalLinks.length);
                        currentUrl = prevShow.getAttribute("data-modal-url") || "";
                        initAnchors();
                    }
                });
                nextButton.addEventListener("click", ()=>{
                    if (nextShow) {
                        modalContent.innerHTML = "";
                        nextShow.click();
                        updateActions(false, currentShowIndex + 1, availableModalLinks.length);
                        currentUrl = nextShow.getAttribute("data-modal-url") || "";
                        initAnchors();
                    }
                });
            }
        }
    }
    function scrollToHash(hash) {
        const targetId = hash.replace(/^#/, "");
        if (!targetId) return;
        const content = modal.querySelector(".show-modal-content");
        const targetSection = modal.querySelector(`#${CSS.escape(targetId)}`);
        if (!content || !targetSection) return;
        const modalContentRect = content.getBoundingClientRect();
        const targetRect = targetSection.getBoundingClientRect();
        const scrollOffset = targetRect.top - modalContentRect.top + content.scrollTop;
        content.scrollTo({
            top: scrollOffset,
            behavior: "smooth"
        });
    }
    // Ticket anchor
    function initAnchors() {
        modal.querySelectorAll("a[href^='#']").forEach((anchor)=>{
            anchor.addEventListener("click", (event)=>{
                event.preventDefault();
                const targetId = anchor.getAttribute("href")?.split("#")[1];
                if (targetId) scrollToHash(`#${targetId}`);
            });
        });
    }
    function closeModal() {
        modal.classList.remove("visible");
        const onTransitionEnd = ()=>{
            modal.removeEventListener("transitionend", onTransitionEnd);
            modalContent.innerHTML = "";
            modal.close();
            updateUrl("");
            modal.setAttribute("data-current-url", "");
            updateActions(true);
            document.documentElement.style.overflow = "auto";
        };
        modal.addEventListener("transitionend", onTransitionEnd);
        resetButtons();
        modal.removeEventListener("keydown", handleEscapeKey);
    }
    function resetButtons() {
        const closeButton = modal.querySelector(".button-close");
        const prevButton = modal.querySelector(".button-prev");
        const nextButton = modal.querySelector(".button-next");
        const newTabButton = modal.querySelector(".button-tab");
        closeButton.replaceWith(closeButton.cloneNode(true));
        prevButton.replaceWith(prevButton.cloneNode(true));
        nextButton.replaceWith(nextButton.cloneNode(true));
        newTabButton.replaceWith(newTabButton.cloneNode(true));
    }
    function handleEscapeKey(event) {
        if (event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
        }
    }
    const modalLinks = document.querySelectorAll("a[data-modal-url]");
    modalLinks.forEach((link)=>{
        const url = link.getAttribute("data-modal-url") || "";
        link.addEventListener("mouseenter", ()=>{
            if (url) preloadContent(url);
        });
        link.addEventListener("click", (event)=>{
            if (!event.ctrlKey && !event.metaKey) {
                event.preventDefault();
                event.stopPropagation();
                openModal(event);
            }
            if (event.ctrlKey || event.metaKey) {
                event.preventDefault();
                event.stopPropagation();
                window.open(link.href, "_blank");
            }
        }, {
            capture: true
        });
    });
    function updateUrl(urlQuery) {
        if (urlQuery !== "") window.history.replaceState(null, document.title, urlQuery);
        else window.history.replaceState(null, document.title, window.location.origin);
    }
}
$691f61a55cf389ac$var$initShowModal();



var $5IiZx = parcelRequire("5IiZx");
function $1d27541b500be4a6$export$9cdf91fbbc5b2bc4(hash = window.location.hash) {
    const id = decodeURIComponent(hash.replace(/^#/, ""));
    if (!id || id === "program") return false;
    return document.getElementById(id)?.classList.contains("program-daily-day") ?? false;
}
function $1d27541b500be4a6$export$eb69eac63ef3ef40(hash = window.location.hash) {
    return [
        "#donate",
        "#manage-donation",
        "#buy"
    ].includes(hash);
}
function $1d27541b500be4a6$export$f79e151f0c660df6(url) {
    return url.pathname + url.search.replace(/%2C/gi, ",") + url.hash;
}


let $f21e01d212f15a26$var$shortlistedIds = [];
function $f21e01d212f15a26$var$initFilter() {
    const programFilter = document.querySelector(".program-filters");
    if (!programFilter) return;
    const HIGHLIGHTS_KEY = "types";
    const highlightFilters = programFilter.querySelectorAll(`input[name="${HIGHLIGHTS_KEY}[]"]`);
    const genreFilters = programFilter.querySelectorAll(`[data-filter-group="genre"] input[name="${HIGHLIGHTS_KEY}[]"]`);
    const accessFilters = programFilter.querySelectorAll(`[data-filter-group="access"] input[name="${HIGHLIGHTS_KEY}[]"]`);
    function getCheckedValues(inputs) {
        return Array.from(inputs).filter((input)=>input.checked).map((input)=>input.value);
    }
    function syncState() {
        const values = getCheckedValues(highlightFilters);
        (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).set(HIGHLIGHTS_KEY, values.join(","));
        const next = new URL(window.location.href);
        const dailyTab = document.getElementById("daily");
        const onDailyTab = dailyTab?.getAttribute("aria-selected") === "true";
        if (onDailyTab || (0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)()) {
            next.searchParams.delete(HIGHLIGHTS_KEY);
            if (!next.hash) next.hash = "program";
        } else {
            if (values.length > 0) next.searchParams.set(HIGHLIGHTS_KEY, values.join(","));
            else next.searchParams.delete(HIGHLIGHTS_KEY);
            if (!next.hash || (0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)(next.hash)) next.hash = "program";
        }
        window.history.replaceState(null, document.title, (0, $1d27541b500be4a6$export$f79e151f0c660df6)(next));
        filterShowList();
        updateAdsVisibility(values.length > 0);
        updateClearButtons();
    }
    highlightFilters.forEach((input)=>{
        input.addEventListener("change", ()=>{
            syncState();
        });
        input.addEventListener("keydown", (event)=>{
            if (event.key === " " || event.key === "Enter") {
                event.preventDefault();
                input.click();
            }
        });
    });
    programFilter.querySelectorAll("[data-clear]").forEach((button)=>{
        button.addEventListener("click", ()=>{
            const group = button.getAttribute("data-clear");
            const groupInputs = programFilter.querySelectorAll(`[data-filter-group="${group}"] input[name="${HIGHLIGHTS_KEY}[]"]`);
            groupInputs.forEach((input)=>{
                input.checked = false;
            });
            syncState();
        });
    });
    const savedHighlights = (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).get(HIGHLIGHTS_KEY)?.split(",") || [
        ""
    ];
    const urlHasTypes = Boolean(new URLSearchParams(window.location.search).get("types")?.trim());
    if (savedHighlights[0] !== "") {
        highlightFilters.forEach((input)=>{
            input.checked = savedHighlights.includes(input.value);
        });
        if (urlHasTypes || !(0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)()) syncState();
        else {
            filterShowList();
            updateAdsVisibility(getCheckedValues(highlightFilters).length > 0);
            updateClearButtons();
        }
    } else {
        filterShowList();
        updateAdsVisibility(getCheckedValues(highlightFilters).length > 0);
        updateClearButtons();
    }
    function filterShowList() {
        const showList = document.querySelector(".show-list");
        if (!showList) return;
        const showItems = showList.querySelectorAll(".show-list-item");
        const selectedGenre = getCheckedValues(genreFilters);
        const selectedAccess = getCheckedValues(accessFilters);
        showItems.forEach((item)=>{
            if (item.classList.contains("show-list-item--ad")) return;
            const itemHighlights = item.getAttribute("data-highlights")?.split(",") || [];
            const genreMatches = selectedGenre.length === 0 || selectedGenre.some((slug)=>itemHighlights.includes(slug));
            const accessMatches = selectedAccess.length === 0 || selectedAccess.some((slug)=>itemHighlights.includes(slug));
            if (genreMatches && accessMatches) item.classList.remove("show-list-item--hidden");
            else item.classList.add("show-list-item--hidden");
        });
        $f21e01d212f15a26$export$1174ea83a5b862e7();
        updateFilterResultsCount();
    }
    function updateClearButtons() {
        programFilter.querySelectorAll("[data-clear]").forEach((button)=>{
            const group = button.getAttribute("data-clear");
            const groupInputs = programFilter.querySelectorAll(`[data-filter-group="${group}"] input[name="${HIGHLIGHTS_KEY}[]"]`);
            const hasSelection = getCheckedValues(groupInputs).length > 0;
            const item = button.closest(".program-filters-clear-item");
            button.hidden = !hasSelection;
            if (item) item.hidden = !hasSelection;
        });
    }
    function updateFilterResultsCount() {
        const results = document.querySelector(".program-filter-results");
        if (!results) return;
        const hasFilters = getCheckedValues(genreFilters).length > 0 || getCheckedValues(accessFilters).length > 0;
        if (!hasFilters) {
            results.hidden = true;
            results.textContent = "";
            return;
        }
        const showList = document.querySelector(".show-list");
        const count = showList ? showList.querySelectorAll(".show-list-item:not(.show-list-item--ad):not(.show-list-item--hidden)").length : 0;
        const resultLabel = count === 1 ? "result" : "results";
        results.hidden = false;
        results.textContent = `Showing ${count} ${resultLabel} from filters`;
    }
    const shortlistCheckbox = programFilter.querySelector("#shortlist");
    if (shortlistCheckbox) {
        if ($f21e01d212f15a26$var$shortlistedIds.length === 0) shortlistCheckbox.disabled = true;
        else {
            shortlistCheckbox.disabled = false;
            $f21e01d212f15a26$export$1174ea83a5b862e7();
        }
        shortlistCheckbox.addEventListener("change", ()=>{
            if (shortlistCheckbox.checked) $f21e01d212f15a26$export$1174ea83a5b862e7();
            else filterShowList();
        });
    }
    document.addEventListener("shortlist:updated", (event)=>{
        $f21e01d212f15a26$var$shortlistedIds = event.detail.slugs;
        if (shortlistCheckbox) {
            shortlistCheckbox.disabled = $f21e01d212f15a26$var$shortlistedIds.length === 0;
            if (!$f21e01d212f15a26$var$shortlistedIds.length) shortlistCheckbox.checked = false;
        }
        filterShowList();
    });
    // Show ads
    function updateAdsVisibility(isHidden) {
        const showList = document.querySelector("ul.show-list");
        if (showList) {
            if (isHidden) showList.classList.add("no-ads");
            else showList.classList.remove("no-ads");
        }
    }
}
$f21e01d212f15a26$var$initFilter();
function $f21e01d212f15a26$export$1174ea83a5b862e7() {
    const programFilter = document.querySelector(".program-filters");
    const shortlistCheckbox = programFilter?.querySelector("#shortlist");
    const showList = document.querySelector(".show-list");
    if (!showList) return;
    const showItems = showList.querySelectorAll(".show-list-item");
    showItems.forEach((item)=>{
        const showId = item.getAttribute("id");
        if (shortlistCheckbox && shortlistCheckbox.checked && $f21e01d212f15a26$var$shortlistedIds.includes(showId?.replace("item-", "") || "")) item.classList.remove("show-list-item--hidden");
    });
}


function $d2b951c41f70e0b4$var$formatBookingDate(iso) {
    const parts = iso.split("-");
    if (parts.length !== 3) return "";
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
}
function $d2b951c41f70e0b4$var$todayIso() {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
}
// Local midnight avoids a UTC shift turning the date into the previous day.
function $d2b951c41f70e0b4$var$isoDatePlusDay(iso) {
    const date = new Date(`${iso}T00:00:00`);
    date.setDate(date.getDate() + 1);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
}
// Accepts m/d/yyyy or mm/dd/yyyy and rejects dates that are not on the calendar.
function $d2b951c41f70e0b4$var$parseBookingDate(value) {
    const match = value.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return "";
    const month = match[1].padStart(2, "0");
    const day = match[2].padStart(2, "0");
    const year = Number(match[3]);
    const iso = `${match[3]}-${month}-${day}`;
    const date = new Date(`${iso}T00:00:00`);
    if (date.getFullYear() !== year || date.getMonth() + 1 !== Number(month) || date.getDate() !== Number(day)) return "";
    return iso;
}
function $d2b951c41f70e0b4$var$syncDateText(nativeInput) {
    const text = nativeInput.parentElement.querySelector(".hotel-booking-date-text");
    if (!text) return;
    text.value = nativeInput.value ? $d2b951c41f70e0b4$var$formatBookingDate(nativeInput.value) : "";
}
// Writes a typed mm/dd/yyyy value onto the hidden date input. Returns "" when it is not a real date.
function $d2b951c41f70e0b4$var$commitDateText(text, nativeInput) {
    const typed = text.value.trim();
    if (!typed) {
        nativeInput.value = "";
        return "";
    }
    const iso = $d2b951c41f70e0b4$var$parseBookingDate(typed);
    if (!iso) return "";
    nativeInput.value = iso;
    text.value = $d2b951c41f70e0b4$var$formatBookingDate(iso);
    return iso;
}
// The visible field is text. The date input over the icon opens the browser calendar.
function $d2b951c41f70e0b4$var$bindDateField(nativeInput) {
    const field = nativeInput.parentElement;
    const text = field.querySelector(".hotel-booking-date-text");
    nativeInput.addEventListener("change", ()=>{
        $d2b951c41f70e0b4$var$syncDateText(nativeInput);
    });
    nativeInput.addEventListener("click", (event)=>{
        if (typeof nativeInput.showPicker !== "function") return;
        const ua = navigator.userAgent;
        // Safari opens from the click itself. showPicker() there leaves a calendar that cannot close.
        const isSafari = /safari/i.test(ua) && !/chrome|chromium|crios|android/i.test(ua);
        if (isSafari) return;
        // Firefox's own click closes the calendar that showPicker() just opened.
        if (/firefox/i.test(ua)) event.preventDefault();
        try {
            nativeInput.showPicker();
        } catch  {
        // The picker is already open.
        }
    });
    text.addEventListener("change", ()=>{
        const typed = text.value.trim();
        const iso = $d2b951c41f70e0b4$var$commitDateText(text, nativeInput);
        if (!typed || iso) nativeInput.dispatchEvent(new Event("change"));
    });
}
// Clear first so a repeated message is announced again.
function $d2b951c41f70e0b4$var$showBookingError(error, message) {
    error.textContent = "";
    error.textContent = message;
}
function $d2b951c41f70e0b4$var$setDateInvalid(input, error, invalid) {
    if (invalid) {
        input.setAttribute("aria-invalid", "true");
        input.setAttribute("aria-describedby", error.id);
    } else {
        input.removeAttribute("aria-invalid");
        input.removeAttribute("aria-describedby");
    }
}
function $d2b951c41f70e0b4$var$initHotelBooking(wrap) {
    const form = wrap.querySelector(".hotel-booking");
    if (!form) return;
    const checkin = form.querySelector("[data-hotel-checkin]");
    const checkout = form.querySelector("[data-hotel-checkout]");
    const checkinText = form.querySelector("[data-hotel-checkin-text]");
    const checkoutText = form.querySelector("[data-hotel-checkout-text]");
    const checkinField = form.querySelector('[name="Checkin"]');
    const checkoutField = form.querySelector('[name="Checkout"]');
    const subsetField = form.querySelector('[name="PromoSubset"]');
    const error = form.querySelector(".hotel-booking-error");
    const dialog = wrap.querySelector(".hotel-booking-dialog");
    const subsetCount = Number(form.getAttribute("data-subset-count")) || 0;
    const submitButton = form.querySelector('[type="submit"]');
    const today = $d2b951c41f70e0b4$var$todayIso();
    if (!checkin.min || checkin.min < today) checkin.min = today;
    if (checkin.value && checkin.value < today) checkin.value = "";
    $d2b951c41f70e0b4$var$bindDateField(checkin);
    $d2b951c41f70e0b4$var$bindDateField(checkout);
    $d2b951c41f70e0b4$var$syncDateText(checkin);
    $d2b951c41f70e0b4$var$syncDateText(checkout);
    checkin.addEventListener("change", ()=>{
        if (!checkin.value) return;
        const min = $d2b951c41f70e0b4$var$isoDatePlusDay(checkin.value);
        checkout.min = min;
        if (checkout.value && checkout.value < min) {
            checkout.value = "";
            $d2b951c41f70e0b4$var$syncDateText(checkout);
        }
    });
    form.addEventListener("submit", (event)=>{
        const start = $d2b951c41f70e0b4$var$commitDateText(checkinText, checkin);
        const end = $d2b951c41f70e0b4$var$commitDateText(checkoutText, checkout);
        $d2b951c41f70e0b4$var$setDateInvalid(checkinText, error, false);
        $d2b951c41f70e0b4$var$setDateInvalid(checkoutText, error, false);
        if (!checkinText.value.trim()) {
            event.preventDefault();
            $d2b951c41f70e0b4$var$showBookingError(error, "Select a check-in date.");
            $d2b951c41f70e0b4$var$setDateInvalid(checkinText, error, true);
            checkinText.focus();
            return;
        }
        if (!start) {
            event.preventDefault();
            $d2b951c41f70e0b4$var$showBookingError(error, "Enter a check-in date as mm/dd/yyyy.");
            $d2b951c41f70e0b4$var$setDateInvalid(checkinText, error, true);
            checkinText.focus();
            return;
        }
        if (start < today) {
            event.preventDefault();
            $d2b951c41f70e0b4$var$showBookingError(error, "Check-in cannot be before today.");
            $d2b951c41f70e0b4$var$setDateInvalid(checkinText, error, true);
            checkinText.focus();
            return;
        }
        if (!checkoutText.value.trim()) {
            event.preventDefault();
            $d2b951c41f70e0b4$var$showBookingError(error, "Select a check-out date.");
            $d2b951c41f70e0b4$var$setDateInvalid(checkoutText, error, true);
            checkoutText.focus();
            return;
        }
        if (!end) {
            event.preventDefault();
            $d2b951c41f70e0b4$var$showBookingError(error, "Enter a check-out date as mm/dd/yyyy.");
            $d2b951c41f70e0b4$var$setDateInvalid(checkoutText, error, true);
            checkoutText.focus();
            return;
        }
        if (end <= start) {
            event.preventDefault();
            $d2b951c41f70e0b4$var$showBookingError(error, "Check-out must be after check-in.");
            $d2b951c41f70e0b4$var$setDateInvalid(checkoutText, error, true);
            checkoutText.focus();
            return;
        }
        $d2b951c41f70e0b4$var$showBookingError(error, "");
        checkinField.value = $d2b951c41f70e0b4$var$formatBookingDate(start);
        checkoutField.value = $d2b951c41f70e0b4$var$formatBookingDate(end);
        if (subsetCount > 1 && dialog) {
            event.preventDefault();
            if (typeof dialog.showModal === "function") dialog.showModal();
        }
    });
    if (!dialog) return;
    const subsetError = dialog.querySelector("[data-subset-error]");
    const nextButton = dialog.querySelector("[data-hotel-booking-next]");
    const closeButton = dialog.querySelector("[data-hotel-booking-close]");
    dialog.addEventListener("close", ()=>{
        if (submitButton) submitButton.focus();
    });
    closeButton.addEventListener("click", ()=>{
        dialog.close();
    });
    nextButton.addEventListener("click", ()=>{
        const selected = dialog.querySelectorAll(".subset:checked");
        if (selected.length !== 1) {
            $d2b951c41f70e0b4$var$showBookingError(subsetError, selected.length === 0 ? "Select a program." : "Select only one program.");
            return;
        }
        $d2b951c41f70e0b4$var$showBookingError(subsetError, "");
        subsetField.value = selected[0].value;
        dialog.close();
        // Programmatic submit does not run the submit listener again.
        form.submit();
    });
}
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".hotel-booking-wrap").forEach($d2b951c41f70e0b4$var$initHotelBooking);
});



// Program ads (the Donate and newsletter tiles in the program grid) arrive the
// first time they scroll into view, once per page view: the headline resolves
// in stepped frames with a cyan/amber split, then the button lands with the
// label shiver (sass/content/_shows-listing.scss). The Passes page's cards
// arrive the same way: their prices resolve (sass/content/_passes.scss).
// Then they rest, clean. With reduced motion, or without this script,
// they're simply there.
// The arrival's longest animation (the button) ends at 0.6s.
const $e6479488f98b40e1$var$ARRIVAL_MS = 700;
function $e6479488f98b40e1$var$initShowAds() {
    const ads = document.querySelectorAll(".show-list-item--ad, .pass-card");
    if (!ads.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const arrive = (ad)=>{
        observer.unobserve(ad);
        if (!ad.classList.contains("is-arrival-pending")) return;
        ad.classList.remove("is-arrival-pending");
        ad.classList.add("is-arriving");
        window.setTimeout(()=>ad.classList.remove("is-arriving"), $e6479488f98b40e1$var$ARRIVAL_MS);
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) arrive(entry.target);
        });
    }, {
        threshold: 0.4
    });
    ads.forEach((ad)=>{
        ad.classList.add("is-arrival-pending");
        observer.observe(ad);
        // Tabbing to the button shows the tile straight away.
        ad.addEventListener("focusin", ()=>arrive(ad), {
            once: true
        });
    });
}
$e6479488f98b40e1$var$initShowAds();



var $7sJ6e = parcelRequire("7sJ6e");
const $584ce42031037bc8$var$disableBodyScroll = $7sJ6e.disableBodyScroll;
const $584ce42031037bc8$var$enableBodyScroll = $7sJ6e.enableBodyScroll;
var $584ce42031037bc8$var$popups = document.querySelectorAll(".video-popup");
if ($584ce42031037bc8$var$popups.length > 0) {
    var $584ce42031037bc8$var$tag = document.createElement("script");
    $584ce42031037bc8$var$tag.src = "https://www.youtube.com/iframe_api";
    var $584ce42031037bc8$var$firstScriptTag = document.getElementsByTagName("script")[0];
    $584ce42031037bc8$var$firstScriptTag.parentNode.insertBefore($584ce42031037bc8$var$tag, $584ce42031037bc8$var$firstScriptTag);
    window.onYouTubeIframeAPIReady = function() {
        $584ce42031037bc8$var$popups.forEach(function(popup) {
            let player = null;
            const dialog = popup.querySelector("dialog");
            const openButton = popup.querySelector(".button-open");
            const closeButton = popup.querySelector(".button-close");
            const youtube = popup.querySelector("[data-youtube]");
            openButton.addEventListener("click", ()=>{
                dialog.showModal();
                // disableBodyScroll(dialog);
                if (!player) player = new YT.Player(youtube, {
                    width: 640,
                    height: 640 * (9 / 16),
                    videoId: youtube.dataset.youtube,
                    playerVars: {
                        // 'controls': 0,
                        color: "white",
                        playsinline: 1,
                        rel: 0
                    },
                    events: {
                        // 'onReady': () => fn(player),
                        onStateChange: (e)=>console.log("onStateChange", Object.keys(YT.PlayerState).find((key)=>YT.PlayerState[key] === e.data))
                    }
                });
                setTimeout(function() {
                    dialog.classList.add("open");
                // player.playVideo();
                }, 25);
            });
            // Click close button to close
            closeButton.addEventListener("click", ()=>{
                dialog.classList.add("closing");
                player.pauseVideo();
                setTimeout(function() {
                    dialog.close();
                }, 300);
            });
            // Click backdrop to close
            dialog.addEventListener("click", (e)=>{
                if (e.target === dialog) {
                    dialog.classList.add("closing");
                    player.pauseVideo();
                    setTimeout(function() {
                        dialog.close();
                    }, 300);
                }
            });
            dialog.addEventListener("close", ()=>{
                dialog.classList.remove("open");
                dialog.classList.remove("closing");
                player.pauseVideo();
            // enableBodyScroll(dialog);
            });
        });
    };
}


jQuery(function($) {
    console.log("spektrix quick add loaded");
    // Use global basket manager if available, fallback to local implementation
    function getBasketData() {
        if (window.BasketManager) return window.BasketManager.get();
        // Fallback for cases where global manager isn't loaded yet
        return jQuery.ajax({
            url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket",
            type: "GET",
            xhrFields: {
                withCredentials: true
            }
        });
    }
    function refreshBasketData() {
        if (window.BasketManager) return window.BasketManager.refresh();
        return getBasketData();
    }
    function countTicketsInBasket(basketData) {
        var ticketCounts = {};
        if (basketData && basketData.tickets) basketData.tickets.forEach(function(ticket) {
            // Create key in the format that matches our select names
            var key = ticket.instance.id + "|" + ticket.planId + "|" + ticket.type.id;
            ticketCounts[key] = (ticketCounts[key] || 0) + 1;
        });
        console.log("Ticket counts from basket:", ticketCounts);
        return ticketCounts;
    }
    function countPassesInBasket(basketData) {
        var passCounts = {};
        if (basketData && basketData.ticketSubscriptions) basketData.ticketSubscriptions.forEach(function(subscription) {
            // Create key using the pricingSetName directly since server handles the mapping
            var key = subscription.pricingSetName;
            passCounts[key] = (passCounts[key] || 0) + 1;
        });
        console.log("Pass counts from basket:", passCounts);
        return passCounts;
    }
    function countMembershipsInBasket(basketData) {
        var membershipCounts = {};
        if (basketData && basketData.membershipSubscriptions) basketData.membershipSubscriptions.forEach(function(subscription) {
            // Track by membership ID - membership is nested in subscription object
            var key = subscription.membership && subscription.membership.id;
            if (key) membershipCounts[key] = true;
        });
        console.log("Membership counts from basket:", membershipCounts);
        return membershipCounts;
    }
    function countReservedSeatsByInstance(basketData) {
        var instanceCounts = {};
        if (basketData && basketData.tickets) basketData.tickets.forEach(function(ticket) {
            var instanceId = ticket.instance.id;
            instanceCounts[instanceId] = (instanceCounts[instanceId] || 0) + 1;
        });
        console.log("Reserved seat counts by instance:", instanceCounts);
        return instanceCounts;
    }
    // A best-available quick-add's tickets in the cart (inc/quick-add.php's
    // best[instance]): by section, as best-available tickets carry their
    // seating area's plan rather than the instance's.
    function bestTickets(basketData, instanceId, bandId) {
        return (basketData && basketData.tickets || []).filter(function(ticket) {
            return ticket.instance.id === instanceId && (!bandId || ticket.band && ticket.band.id === bandId);
        });
    }
    function bestInstance(select) {
        var matches = select.name.match(/^best\[(.*?)\]$/);
        return matches ? matches[1] : null;
    }
    function bestBand($form, instanceId) {
        return $form.find('[name="band[' + instanceId + ']"]');
    }
    function populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, basketData) {
        var hasExistingItems = false;
        // Best-available seats: the count shown is the chosen section's, and a
        // section with seats in the cart is chosen over the dearest.
        $form.find('select[name^="best["]').each(function() {
            var $select = $(this);
            var instanceId = bestInstance(this);
            var $band = bestBand($form, instanceId);
            var counts = {};
            bestTickets(basketData, instanceId).forEach(function(ticket) {
                var bandId = ticket.band ? ticket.band.id : "";
                counts[bandId] = (counts[bandId] || 0) + 1;
                hasExistingItems = true;
            });
            $select.data("bandCounts", counts);
            if ($band.is("select")) {
                var $held = $band.find("option").filter(function() {
                    return counts[this.value] > 0;
                });
                if ($held.length) $band.val($held.first().val());
            }
            var count = counts[$band.val()] || 0;
            $select.val(count).attr("data-original-count", count);
            // Get Tickets, which opens this form's pop-up, and its copies (the
            // Shortlist's): the seats in the cart, picked by either way.
            var held = bestTickets(basketData, instanceId).length;
            $('[data-quick-add-open="' + instanceId + '"]').text(held ? held + (held === 1 ? " Seat" : " Seats") + " in Cart" : "Get Tickets");
        });
        // Handle tickets (both selects and hidden inputs)
        $form.find('select[name^="tickets["], input[type="hidden"][name^="tickets["]').each(function() {
            var $element = $(this);
            var name = $element.attr("name");
            // Parse structured naming: tickets[instance][plan][type]
            var matches = name.match(/tickets\[(.*?)\]\[(.*?)\]\[(.*?)\]/);
            if (matches) {
                var key = matches[1] + "|" + matches[2] + "|" + matches[3];
                var existingCount = ticketCounts[key] || 0;
                // Only update value for selects, not hidden inputs (preserve their preset values)
                if ($element.is('select')) $element.val(existingCount);
                $element.attr("data-original-count", existingCount);
                console.log("Set ticket element", name, "original count to", existingCount);
                if (existingCount > 0) hasExistingItems = true;
            }
        });
        // Handle passes
        $form.find('select[name^="passes["]').each(function() {
            var $select = $(this);
            var name = $select.attr("name");
            // Parse structured naming: passes[pricingSetId][pricingSetName]
            var matches = name.match(/passes\[(.*?)\]\[(.*?)\]/);
            if (matches) {
                var pricingSetId = matches[1];
                var pricingSetName = matches[2];
                var existingCount = passCounts[pricingSetName] || 0;
                $select.attr("data-original-count", existingCount);
                console.log("Set pass select", name, "to", existingCount, "original count");
                if (passCounts[pricingSetName] > 0) {
                    $select.val(existingCount);
                    hasExistingItems = true;
                }
            }
        });
        // Handle memberships (both checkboxes and hidden inputs)
        $form.find('input[name^="memberships["]').each(function() {
            var $input = $(this);
            var name = $input.attr("name");
            var isHidden = $input.attr("type") === "hidden";
            // Parse structured naming: memberships[membershipId]
            var matches = name.match(/memberships\[(.*?)\]/);
            if (matches) {
                var membershipId = matches[1];
                var isInBasket = membershipCounts[membershipId] || false;
                if (isHidden) {
                    // For hidden inputs, set data-original-count based on basket (0 or 1)
                    // Don't modify the value, preserve what's in HTML
                    $input.attr("data-original-count", isInBasket ? "1" : "0");
                    console.log("Set membership hidden input", name, "original count:", isInBasket ? 1 : 0, "current value:", $input.val());
                } else {
                    // For checkboxes, only update state if not already checked
                    // This preserves pre-checked state from HTML (e.g., for addAll mode)
                    if (!$input.is(':checked')) $input.prop('checked', isInBasket);
                    $input.attr("data-original-state", isInBasket ? "1" : "0");
                    console.log("Set membership checkbox", name, "original state:", isInBasket, "current checked:", $input.is(':checked'));
                }
                if (isInBasket) hasExistingItems = true;
            }
        });
        // Handle reserved seating tickets (both selects and hidden inputs)
        $form.find('select[name^="reserved["], input[type="hidden"][name^="reserved["]').each(function() {
            var $element = $(this);
            var name = $element.attr("name");
            // Parse structured naming: reserved[instance][priceBand]
            var matches = name.match(/reserved\[(.*?)\]\[(.*?)\]/);
            if (matches) {
                // Reserved tickets are always new, set original count to 0
                // Don't modify the value for either selects or hidden inputs
                $element.attr("data-original-count", "0");
                console.log("Set reserved ticket element", name, "original count to 0, current value:", $element.val());
            }
        });
        // Handle reserved seating buttons
        if (basketData) {
            var instanceCounts = countReservedSeatsByInstance(basketData);
            // Handle buttons with data-instance-id (preferred). Not best-available's
            // "Choose your seats": its stepper shows the count.
            $form.find('a[data-instance-id]').not('.quick-add-seats').each(function() {
                var $button = $(this);
                var instanceId = $button.attr('data-instance-id');
                var seatCount = instanceCounts[instanceId] || 0;
                if (seatCount > 0) {
                    $button.text(seatCount + (seatCount === 1 ? ' Seat Booked - Update' : ' Seats Booked - Update'));
                    hasExistingItems = true;
                    console.log("Updated Choose Seats button for instance", instanceId, "to show", seatCount, "seats");
                } else {
                    $button.text('Choose Seats');
                    console.log("Reset Choose Seats button for instance", instanceId, "to default text");
                }
            });
        }
        // Update button text based on whether user has existing items
        updateSubmitButtonText($form, hasExistingItems);
        syncQuickAddButtons($form);
    }
    // A quick-add's Add to Cart and Quick Buy wait for a quantity
    // (inc/quick-add.php renders them aria-disabled): Add to Cart (Update
    // Cart) once one is chosen or the cart has some to change, Quick Buy once
    // one is chosen. aria-disabled rather than disabled, which is for while
    // they're busy (and which the Shortlist's older widget reads as busy).
    function syncQuickAddButtons($form) {
        var selects = $form.find('select[name^="tickets["], select[name^="best["]').toArray();
        if (!selects.length) return;
        var chosen = selects.some(function(select) {
            return parseInt(select.value) > 0;
        });
        var held = selects.some(function(select) {
            return parseInt(select.getAttribute("data-original-count")) > 0;
        });
        $form.find(".quick-add-submit").attr("aria-disabled", String(!(chosen || held)));
        $form.find("[data-instant-buy]").attr("aria-disabled", String(!chosen));
    }
    function waitsForQuantity(button) {
        return button.getAttribute("aria-disabled") === "true";
    }
    function updateSubmitButtonText($form, hasExistingTickets) {
        var $submitButton = $form.find('button[type="submit"], button.push_button');
        if ($submitButton.length) {
            var customAddText = $submitButton.attr('data-add-text');
            var customUpdateText = $submitButton.attr('data-update-text');
            var addText = customAddText || "Add to Cart";
            var updateText = customUpdateText || "Update Cart";
            var buttonText = hasExistingTickets ? updateText : addText;
            $submitButton.text(buttonText);
            console.log("Updated button text to:", buttonText);
        }
        // Handle already-in-cart warning
        var $warningDiv = $form.find('[data-already-in-cart]');
        if ($warningDiv.length) {
            if (hasExistingTickets) {
                $warningDiv.html('You already have items in the cart, you can try adding this item but be aware there could be a conflict or items added more than once. You can also <a href="#" class="clear-cart-link" style="text-decoration: underline;">click here to clear your cart</a>.').show();
                // Set up clear cart handler (remove old handlers first to avoid duplicates)
                $warningDiv.find('.clear-cart-link').off('click').on('click', function(e) {
                    e.preventDefault();
                    if (!confirm('Are you sure you want to clear your entire cart?')) return;
                    console.log('Clearing cart...');
                    jQuery.ajax({
                        url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/clear",
                        type: "POST",
                        xhrFields: {
                            withCredentials: true
                        }
                    }).then(function(response) {
                        console.log('Cart cleared successfully', response);
                        // Refresh basket data and update all forms
                        return refreshBasketData().then(function(refreshedData) {
                            console.log("Refreshed basket after clear:", refreshedData);
                            var ticketCounts = countTicketsInBasket(refreshedData);
                            var passCounts = countPassesInBasket(refreshedData);
                            var membershipCounts = countMembershipsInBasket(refreshedData);
                            $('.tickets-form').each(function() {
                                populateExistingQuantities($(this), ticketCounts, passCounts, membershipCounts, refreshedData);
                            });
                            // Update cart count in navigation
                            var totalItems = window.BasketManager ? window.BasketManager.getCount(refreshedData) : 0;
                            if (window.updateCartCount) window.updateCartCount(totalItems, true);
                        });
                    }).catch(function(error) {
                        console.error('Error clearing cart:', error);
                        alert('Error clearing cart. Please try again.');
                    });
                });
            } else $warningDiv.hide();
        }
    }
    // Shared function to process form selects and determine cart operations
    function processFormSelects($form, basketData) {
        var ticketsToAdd = [];
        var ticketsToRemove = [];
        var passesToAdd = [];
        var passesToRemove = [];
        var membershipsToAdd = [];
        var membershipsToRemove = [];
        var hasChanges = false;
        // Process tickets from this form (both selects and hidden inputs)
        $form.find('select[name^="tickets["], input[type="hidden"][name^="tickets["]').each(function() {
            var $element = $(this);
            var name = $element.attr("name");
            var isHidden = $element.attr("type") === "hidden";
            var originalCount = parseInt($element.attr("data-original-count")) || 0;
            var newCount = parseInt($element.val()) || 0;
            var difference = newCount - originalCount;
            if (difference === 0) return;
            hasChanges = true;
            console.log("Processing ticket " + (isHidden ? "hidden input" : "select") + ":", name, "Original:", originalCount, "New:", newCount, "Difference:", difference);
            // Parse structured naming: tickets[instance][plan][type]
            var matches = name.match(/tickets\[(.*?)\]\[(.*?)\]\[(.*?)\]/);
            if (!matches) {
                console.log("Warning: Could not parse ticket element name:", name);
                return;
            }
            var instanceId = matches[1];
            var planId = matches[2];
            var typeId = matches[3];
            if (difference > 0) // Add tickets
            for(var i = 0; i < difference; i++)ticketsToAdd.push({
                instance: instanceId,
                seatingPlan: planId,
                type: typeId
            });
            else if (difference < 0) // Remove tickets
            {
                if (basketData && basketData.tickets) {
                    var ticketsToRemoveForThisSelect = basketData.tickets.filter(function(ticket) {
                        return ticket.instance.id === instanceId && ticket.planId === planId && ticket.type.id === typeId;
                    }).slice(0, Math.abs(difference));
                    ticketsToRemoveForThisSelect.forEach(function(ticket) {
                        ticketsToRemove.push(ticket.id);
                    });
                }
            }
        });
        // Process passes from this form
        $form.find('select[name^="passes["]').each(function() {
            var $select = $(this);
            var name = $select.attr("name");
            var originalCount = parseInt($select.attr("data-original-count")) || 0;
            var newCount = parseInt($select.val()) || 0;
            var difference = newCount - originalCount;
            if (difference === 0) return;
            hasChanges = true;
            console.log("Processing pass select:", name, "Original:", originalCount, "New:", newCount, "Difference:", difference);
            // Parse structured naming: passes[pricingSetId][pricingSetName]
            var matches = name.match(/passes\[(.*?)\]\[(.*?)\]/);
            if (!matches) {
                console.log("Warning: Could not parse pass select name:", name);
                return;
            }
            var pricingSetId = matches[1];
            var pricingSetName = matches[2];
            if (difference > 0) // Add passes - API expects array of objects with pricingSetId and quantity
            passesToAdd.push({
                pricingSetId: pricingSetId,
                quantity: difference
            });
            else if (difference < 0) // Remove passes
            {
                if (basketData && basketData.ticketSubscriptions) {
                    var passesToRemoveForThisSelect = basketData.ticketSubscriptions.filter(function(subscription) {
                        return subscription.pricingSetName === pricingSetName;
                    }).slice(0, Math.abs(difference));
                    passesToRemoveForThisSelect.forEach(function(subscription) {
                        passesToRemove.push(subscription.id);
                    });
                }
            }
        });
        // Process reserved seating tickets from this form (both selects and hidden inputs)
        var reservedToAdd = [];
        $form.find('select[name^="reserved["], input[type="hidden"][name^="reserved["]').each(function() {
            var $element = $(this);
            var name = $element.attr("name");
            var originalCount = parseInt($element.attr("data-original-count")) || 0;
            var newCount = parseInt($element.val()) || 0;
            var difference = newCount - originalCount;
            if (difference === 0) return;
            hasChanges = true;
            console.log("Processing reserved ticket element:", name, "Original:", originalCount, "New:", newCount, "Difference:", difference);
            // Parse structured naming: reserved[instance][priceBand]
            // Get priceBand from: https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/instances/{instanceId}/price-list
            var matches = name.match(/reserved\[(.*?)\]\[(.*?)\]/);
            if (!matches) {
                console.log("Warning: Could not parse reserved ticket element name:", name);
                return;
            }
            var instanceId = matches[1];
            var priceBandId = matches[2];
            if (difference > 0) // Add reserved tickets via best-available endpoint
            reservedToAdd.push({
                instance: instanceId,
                priceBand: priceBandId,
                quantity: difference
            });
        // Note: Removal of reserved tickets would use regular ticket removal (if needed in future)
        });
        // Best-available seats (inc/quick-add.php's best[instance], in the
        // section band[instance]): the cart ends up with that many there. More
        // asks for the whole party's seats again, so they sit together, and
        // lets the old ones go (executeCartUpdates); fewer lets the last go.
        $form.find('select[name^="best["]').each(function() {
            var instanceId = bestInstance(this);
            var bandId = bestBand($form, instanceId).val();
            var originalCount = parseInt(this.getAttribute("data-original-count")) || 0;
            var newCount = parseInt(this.value) || 0;
            if (!instanceId || !bandId || newCount === originalCount) return;
            hasChanges = true;
            var held = bestTickets(basketData, instanceId, bandId);
            if (newCount > held.length) reservedToAdd.push({
                instance: instanceId,
                priceBand: bandId,
                quantity: newCount,
                added: newCount - held.length,
                replace: held.map(function(ticket) {
                    return ticket.id;
                })
            });
            else held.slice(newCount).forEach(function(ticket) {
                ticketsToRemove.push(ticket.id);
            });
        });
        // Process memberships from this form (both checkboxes and hidden inputs)
        $form.find('input[name^="memberships["]').each(function() {
            var $input = $(this);
            var name = $input.attr("name");
            var isHidden = $input.attr("type") === "hidden";
            var originalState, newState;
            if (isHidden) {
                // For hidden inputs, check if value > 0
                originalState = parseInt($input.attr("data-original-count")) || 0;
                newState = parseInt($input.val()) || 0;
                if (originalState === newState) return;
                hasChanges = true;
                console.log("Processing membership hidden input:", name, "Original:", originalState, "New:", newState);
            } else {
                // For checkboxes, check checked state
                originalState = $input.attr("data-original-state") === "1";
                newState = $input.is(':checked');
                if (originalState === newState) return;
                hasChanges = true;
                console.log("Processing membership checkbox:", name, "Original:", originalState, "New:", newState);
            }
            // Parse structured naming: memberships[membershipId]
            var matches = name.match(/memberships\[(.*?)\]/);
            if (!matches) {
                console.log("Warning: Could not parse membership input name:", name);
                return;
            }
            var membershipId = matches[1];
            // For both hidden and checkbox: if new value is truthy and original was falsy, add it
            if (newState && !originalState || isHidden && newState > originalState) // Add membership - API expects array of objects with membership property
            membershipsToAdd.push({
                membership: membershipId
            });
            else if (!newState && originalState || isHidden && newState < originalState) // Remove membership
            {
                if (basketData && basketData.membershipSubscriptions) {
                    var membershipToRemove = basketData.membershipSubscriptions.find(function(subscription) {
                        return subscription.membership && subscription.membership.id === membershipId;
                    });
                    if (membershipToRemove) // Use the subscription ID (not the membership ID) for deletion
                    membershipsToRemove.push(membershipToRemove.id);
                }
            }
        });
        return {
            ticketsToAdd: ticketsToAdd,
            ticketsToRemove: ticketsToRemove,
            passesToAdd: passesToAdd,
            passesToRemove: passesToRemove,
            membershipsToAdd: membershipsToAdd,
            membershipsToRemove: membershipsToRemove,
            reservedToAdd: reservedToAdd,
            hasChanges: hasChanges
        };
    }
    // The best seats left in a section (docs/best-available.md). Resolves
    // with the tickets, seat names and all.
    function bestAvailable(instanceId, bandId, quantity) {
        return jQuery.ajax({
            url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets/best-available",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify({
                instance: instanceId,
                priceBands: [
                    bandId
                ],
                quantity: quantity
            }),
            xhrFields: {
                withCredentials: true
            }
        });
    }
    // The ids go in unencoded, comma-separated (CLAUDE.md).
    function removeTickets(ticketIds) {
        return jQuery.ajax({
            url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets?ticketIds=" + ticketIds.join(","),
            type: "DELETE",
            xhrFields: {
                withCredentials: true
            }
        });
    }
    // Shared function to execute cart update API calls
    function executeCartUpdates(ticketsToAdd, ticketsToRemove, passesToAdd, passesToRemove, membershipsToAdd, membershipsToRemove, reservedToAdd) {
        var promises = [];
        console.log("Final tickets to add:", ticketsToAdd);
        console.log("Final tickets to remove:", ticketsToRemove);
        console.log("Final passes to add:", passesToAdd);
        console.log("Final passes to remove:", passesToRemove);
        console.log("Final memberships to add:", membershipsToAdd);
        console.log("Final memberships to remove:", membershipsToRemove);
        console.log("Final reserved tickets to add:", reservedToAdd);
        // jQuery.ajax({
        //   url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets/best-available",
        //   type: "POST",
        //   contentType: "application/json",
        //   data: JSON.stringify({
        //     "instance": "1801APGQPRKNVLCHGSKJBCTJKDRMGPLNL",
        //     "quantity": 2
        //   }),
        //   xhrFields: {
        //     withCredentials: true,
        //   },
        // })
        if (ticketsToAdd.length > 0) {
            console.log("Making ADD request for", ticketsToAdd.length, "tickets");
            promises.push(jQuery.ajax({
                url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(ticketsToAdd),
                xhrFields: {
                    withCredentials: true
                }
            }));
        }
        if (ticketsToRemove.length > 0) {
            console.log("Making DELETE request for", ticketsToRemove.length, "tickets");
            // Build URL with ticketIds as comma-separated values (don't encode commas)
            var deleteUrl = "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/tickets";
            var ticketIdsList = ticketsToRemove.join(",");
            deleteUrl += "?ticketIds=" + ticketIdsList;
            console.log("DELETE URL:", deleteUrl);
            promises.push(jQuery.ajax({
                url: deleteUrl,
                type: "DELETE",
                xhrFields: {
                    withCredentials: true
                }
            }));
        }
        if (passesToAdd.length > 0) {
            console.log("Making ADD request for", passesToAdd.length, "pass(es)");
            promises.push(jQuery.ajax({
                url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/ticket-subscriptions",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(passesToAdd),
                xhrFields: {
                    withCredentials: true
                }
            }));
        }
        if (passesToRemove.length > 0) {
            console.log("Making DELETE request for", passesToRemove.length, "pass(es)");
            // Make individual DELETE requests for each pass ID
            passesToRemove.forEach(function(passId) {
                var deletePassUrl = "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/ticket-subscriptions/" + passId;
                console.log("DELETE Pass URL:", deletePassUrl);
                promises.push(jQuery.ajax({
                    url: deletePassUrl,
                    type: "DELETE",
                    xhrFields: {
                        withCredentials: true
                    }
                }));
            });
        }
        if (membershipsToAdd.length > 0) {
            console.log("Making ADD request for", membershipsToAdd.length, "membership(s)");
            promises.push(jQuery.ajax({
                url: "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/membership-subscriptions",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(membershipsToAdd),
                xhrFields: {
                    withCredentials: true
                }
            }));
        }
        if (membershipsToRemove.length > 0) {
            console.log("Making DELETE request for", membershipsToRemove.length, "membership(s)");
            // Make individual DELETE requests for each membership ID
            membershipsToRemove.forEach(function(membershipId) {
                var deleteMembershipUrl = "https://ticketing.purchase.pushfestival.ca/pushfestivalvancouver/api/v3/basket/membership-subscriptions/" + membershipId;
                console.log("DELETE Membership URL:", deleteMembershipUrl);
                promises.push(jQuery.ajax({
                    url: deleteMembershipUrl,
                    type: "DELETE",
                    xhrFields: {
                        withCredentials: true
                    }
                }));
            });
        }
        if (reservedToAdd.length > 0) {
            console.log("Making ADD request for", reservedToAdd.length, "reserved ticket(s) via best-available");
            // Make individual POST requests for each reserved ticket group
            reservedToAdd.forEach(function(reservedTicket) {
                console.log("POST best-available:", reservedTicket);
                var replace = reservedTicket.replace || [];
                var seats = bestAvailable(reservedTicket.instance, reservedTicket.priceBand, reservedTicket.quantity);
                if (replace.length) // Seats for the whole party, then the ones held go. If Spektrix
                // can't seat them all together, the extra seats on their own.
                seats = Promise.resolve(seats).then(function(tickets) {
                    return Promise.resolve(removeTickets(replace)).then(function() {
                        return tickets;
                    });
                }, function() {
                    return bestAvailable(reservedTicket.instance, reservedTicket.priceBand, reservedTicket.added);
                });
                promises.push(seats);
            });
        }
        if (promises.length === 0) {
            console.log("No changes to make");
            return Promise.resolve([]); // Return resolved promise with empty array
        }
        console.log("Executing", promises.length, "API request(s)");
        return Promise.all(promises);
    }
    // Shared function to build success message: what changed ("2 tickets
    // added."), with the cart link on the line below (cartLink()).
    function buildSuccessMessage(ticketsToAdd, ticketsToRemove, passesToAdd, passesToRemove, membershipsToAdd, membershipsToRemove, reservedToAdd) {
        var message = "";
        if (ticketsToAdd.length > 0) message += ticketsToAdd.length + (ticketsToAdd.length === 1 ? " ticket" : " tickets") + " added. ";
        if (ticketsToRemove.length > 0) message += ticketsToRemove.length + (ticketsToRemove.length === 1 ? " ticket" : " tickets") + " removed. ";
        if (passesToAdd.length > 0) {
            var totalPassQuantity = passesToAdd.reduce(function(sum, pass) {
                return sum + pass.quantity;
            }, 0);
            message += totalPassQuantity + (totalPassQuantity === 1 ? " pass" : " passes") + " added. ";
        }
        if (passesToRemove.length > 0) message += passesToRemove.length + (passesToRemove.length === 1 ? " pass" : " passes") + " removed. ";
        if (membershipsToAdd.length > 0) message += membershipsToAdd.length + (membershipsToAdd.length === 1 ? " membership" : " memberships") + " added. ";
        if (membershipsToRemove.length > 0) message += membershipsToRemove.length + (membershipsToRemove.length === 1 ? " membership" : " memberships") + " removed. ";
        if (reservedToAdd.length > 0) {
            var totalReservedQuantity = reservedToAdd.reduce(function(sum, reserved) {
                return sum + (reserved.added || reserved.quantity);
            }, 0);
            message += totalReservedQuantity + (totalReservedQuantity === 1 ? " seat" : " seats") + " added. ";
        }
        return message;
    }
    function cartLink() {
        return '<br><a href="/ticketing/cart/">Go to cart &amp; checkout &rarr;</a>';
    }
    // One-Click Buy's button (scripts.js opens it), when push-donations turns
    // it on: it checks out the cart in a pop-up (docs/one-click-buy.md).
    function oneClickBuyButton() {
        return window.PUSH_ONE_CLICK_BUY ? ' <button type="button" class="button small" data-one-click-buy>Quick Buy</button>' : "";
    }
    // Shared function to refresh forms after cart update
    function refreshFormsAfterUpdate(data, $formsToUpdate) {
        return refreshBasketData().then(function(refreshedData) {
            console.log("Updated basket:", refreshedData);
            var ticketCounts = countTicketsInBasket(refreshedData);
            var passCounts = countPassesInBasket(refreshedData);
            var membershipCounts = countMembershipsInBasket(refreshedData);
            $formsToUpdate.each(function() {
                var $form = $(this);
                populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, refreshedData);
            });
            // Update cart count in navigation with animation
            var totalItems = window.BasketManager ? window.BasketManager.getCount(refreshedData) : 0;
            if (window.updateCartCount) window.updateCartCount(totalItems, true);
            return refreshedData;
        });
    }
    // Shared function to show no changes message
    function showNoChangesMessage($targetElement) {
        $targetElement.find ? $targetElement.find(".success, .info, .error").remove() : $targetElement.siblings(".success, .info, .error").remove();
        var $message = $('<p class="info" style="text-align: center; margin: 1rem 0;">No changes made to your cart.</p>');
        if ($targetElement.find) // Form element - append inside
        $targetElement.append($message);
        else // Button element - insert after
        $targetElement.after($message);
        setTimeout(function() {
            $message.fadeOut();
        }, 3000);
    }
    // A quick-add's online sales close at its data-sale-end (inc/quick-add.php),
    // which a cached page can outlive: from then it says Not on sale, as a
    // fresh page would, and so does the Shortlist, which reads the same form.
    // Runs on each container initSpektrixForms() gets and again when the next
    // close comes. Returns whether any quick-add in scope has closed.
    var saleEndTimer = null;
    var nextSaleEnd = Infinity;
    function closeEndedSales(scope) {
        var now = Date.now();
        var closed = false;
        var $scope = $(scope || document);
        $scope.find(".quick-add[data-sale-end]").addBack(".quick-add[data-sale-end]").each(function() {
            var end = Date.parse(this.getAttribute("data-sale-end"));
            if (isNaN(end)) return;
            if (end > now) {
                if (end < nextSaleEnd) {
                    nextSaleEnd = end;
                    clearTimeout(saleEndTimer);
                    // setTimeout holds at most about 24 days.
                    saleEndTimer = setTimeout(function() {
                        nextSaleEnd = Infinity;
                        closeEndedSales();
                    }, Math.min(end - now + 1000, 2147483647));
                }
                return;
            }
            closed = true;
            var $quickAdd = $(this).removeAttr("data-sale-end");
            $quickAdd.children(".quick-add-controls, .quick-add-open, .quick-add-dialog, .success, .info, .error").remove();
            $quickAdd.append('<span class="quick-add-status">Not on sale</span>');
        });
        return closed;
    }
    // Shared function to handle cart errors
    function handleCartError(error, $targetElement) {
        console.error("Error updating cart:", error);
        $targetElement.find ? $targetElement.find(".success, .info, .error").remove() : $targetElement.siblings(".success, .info, .error").remove();
        // Spektrix refuses tickets it can't sell (4xx): most likely sold out,
        // fewer left than asked for, or online sales just closed.
        var status = error && typeof error.status === "number" ? error.status : null;
        var text = "Please try again or clear cart and try again.";
        if (closeEndedSales($targetElement)) text = "Online sales for this showtime have closed.";
        else if (status === 0 && navigator.onLine === false) text = "Couldn\u2019t reach the box office. Check your connection and try again.";
        else if (status === 0 || status >= 400 && status < 500) // 0 online: Spektrix's error responses (a 500, say) carry no CORS
        // headers, so the browser hides them. Most likely a refusal.
        text = "These tickets couldn\u2019t be added: the showtime may have sold out, or have fewer tickets left than you chose.";
        else if (status >= 500) text = "The box office didn\u2019t respond. Please try again in a moment.";
        var $errorMessage = $('<p class="error" style="text-align: center; margin: 1rem 0; color: red;"></p>').text(text);
        if ($targetElement.find) // Form element - append inside
        $targetElement.append($errorMessage);
        else // Button element - insert after
        $targetElement.after($errorMessage);
    }
    // Global function for Add All to Cart functionality
    window.submitAllForms = function() {
        console.log('Submit All Forms triggered');
        var allTicketsToAdd = [];
        var allTicketsToRemove = [];
        var allPassesToAdd = [];
        var allPassesToRemove = [];
        var allMembershipsToAdd = [];
        var allMembershipsToRemove = [];
        var allReservedToAdd = [];
        var hasAnyChanges = false;
        // Get current basket data once
        var basketData = window.BasketManager ? window.BasketManager.data : null;
        // Add All belongs to the underlying page, not a show opened for review.
        $('.tickets-form').not('shortlist-widget .tickets-form').each(function() {
            var $form = $(this);
            var formChanges = processFormSelects($form, basketData);
            if (formChanges.hasChanges) {
                hasAnyChanges = true;
                // Merge this form's changes into the aggregate arrays
                allTicketsToAdd = allTicketsToAdd.concat(formChanges.ticketsToAdd);
                allTicketsToRemove = allTicketsToRemove.concat(formChanges.ticketsToRemove);
                allPassesToAdd = allPassesToAdd.concat(formChanges.passesToAdd);
                allPassesToRemove = allPassesToRemove.concat(formChanges.passesToRemove);
                allMembershipsToAdd = allMembershipsToAdd.concat(formChanges.membershipsToAdd);
                allMembershipsToRemove = allMembershipsToRemove.concat(formChanges.membershipsToRemove);
                allReservedToAdd = allReservedToAdd.concat(formChanges.reservedToAdd);
            }
        });
        if (!hasAnyChanges) {
            showNoChangesMessage($('.add-all-button'));
            return;
        }
        console.log('Aggregated data:', {
            ticketsToAdd: allTicketsToAdd,
            ticketsToRemove: allTicketsToRemove,
            passesToAdd: allPassesToAdd,
            passesToRemove: allPassesToRemove,
            membershipsToAdd: allMembershipsToAdd,
            membershipsToRemove: allMembershipsToRemove,
            reservedToAdd: allReservedToAdd
        });
        // Disable button and show loading
        $('.add-all-button').prop('disabled', true).text('Processing...');
        // Execute all cart updates using shared function
        executeCartUpdates(allTicketsToAdd, allTicketsToRemove, allPassesToAdd, allPassesToRemove, allMembershipsToAdd, allMembershipsToRemove, allReservedToAdd).then(function(responses) {
            console.log("Add All responses:", responses);
            // Build and display success message
            var message = buildSuccessMessage(allTicketsToAdd, allTicketsToRemove, allPassesToAdd, allPassesToRemove, allMembershipsToAdd, allMembershipsToRemove, allReservedToAdd);
            $('.add-all-button').after('<p class="success" style="text-align: center; margin: 1rem 0; color: green; font-weight: bold;">' + message.trim() + cartLink() + oneClickBuyButton() + '</p>');
            // Refresh all forms after update
            refreshFormsAfterUpdate(responses, $('.tickets-form'));
            $('.add-all-button').prop('disabled', false);
            // Update button text based on new basket contents
            if (window.updateAddAllButtonText) window.updateAddAllButtonText();
            else {
                // Fallback: determine button text based on updated basket
                var hasExistingItems = basketData && basketData.tickets && basketData.tickets.length > 0 || basketData && basketData.ticketSubscriptions && basketData.ticketSubscriptions.length > 0 || basketData && basketData.membershipSubscriptions && basketData.membershipSubscriptions.length > 0;
                var buttonText = hasExistingItems ? "Update Cart" : "Add All to Cart";
                $('.add-all-button').text(buttonText);
            }
        }).catch(function(error) {
            $('.add-all-button').prop('disabled', false);
            handleCartError(error, $('.add-all-button'));
            // Update button text based on current basket contents even after error
            if (window.updateAddAllButtonText) window.updateAddAllButtonText();
            else $('.add-all-button').text('Add All to Cart'); // fallback
        });
    };
    // Initialize all spektrix forms within a container
    function initSpektrixForms(container) {
        container = container || document;
        closeEndedSales(container);
        $(container).find('.tickets-form').each(function() {
            var $form = $(this);
            // Skip if already initialized
            if ($form.data('spektrix-initialized')) return;
            $form.data('spektrix-initialized', true);
            var currentBasketData = null;
            // Use shared basket data to populate existing quantities
            getBasketData().then(function(basketData) {
                currentBasketData = basketData;
                var ticketCounts = countTicketsInBasket(basketData);
                var passCounts = countPassesInBasket(basketData);
                var membershipCounts = countMembershipsInBasket(basketData);
                populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, basketData);
            });
            // Choosing a section shows its seats in the cart. A first choice (none
            // in the cart in either) keeps the number chosen.
            $form.on("change", "select.quick-add-band", function() {
                var $quantity = $form.find('select[name="best[' + this.name.slice(5, -1) + ']"]');
                var counts = $quantity.data("bandCounts") || {};
                var held = counts[this.value] || 0;
                var wasHeld = parseInt($quantity.attr("data-original-count")) || 0;
                $quantity.attr("data-original-count", held);
                if (held || wasHeld) {
                    $quantity.val(held);
                    $quantity[0].dispatchEvent(new Event("change", {
                        bubbles: true
                    }));
                }
            });
            $form.on("change input", 'select[name^="tickets["], select[name^="best["]', function() {
                syncQuickAddButtons($form);
            });
            // Quick Buy (inc/quick-add.php): put the chosen tickets in the cart,
            // then check it out in One-Click Buy's pop-up (scripts.js).
            var $instantBuy = $form.find("[data-instant-buy]");
            $instantBuy.prop("hidden", !window.PUSH_ONE_CLICK_BUY);
            $instantBuy.on("click", function() {
                var button = this;
                if (waitsForQuantity(button)) return;
                var basketData = window.BasketManager ? window.BasketManager.data : currentBasketData;
                var changes = processFormSelects($form, basketData);
                $instantBuy.prop("disabled", true);
                var ready = changes.hasChanges ? executeCartUpdates(changes.ticketsToAdd, changes.ticketsToRemove, changes.passesToAdd, changes.passesToRemove, changes.membershipsToAdd, changes.membershipsToRemove, changes.reservedToAdd).then(function() {
                    return refreshFormsAfterUpdate(null, $form);
                }).then(function(data) {
                    currentBasketData = data;
                }) : Promise.resolve();
                ready.then(function() {
                    $form.find(".success, .info, .error").remove();
                    // From the Get Tickets pop-up: it closes first (a modal dialog
                    // would sit above One-Click Buy's), giving focus back to Get
                    // Tickets, which One-Click Buy then returns to.
                    var dialog = $form.closest("dialog")[0];
                    var trigger = button;
                    if (dialog && dialog.open) {
                        dialog.close();
                        trigger = document.activeElement !== document.body ? document.activeElement : null;
                    }
                    window.openOneClickBuy(trigger);
                }).catch(function(error) {
                    handleCartError(error, $form);
                }).then(function() {
                    $instantBuy.prop("disabled", false);
                });
            });
            // Skip individual form submission if in Add All mode
            $form.on("submit", function(e) {
                if (window.addAllMode && !$form.closest('shortlist-widget, .quick-add-dialog').length) {
                    e.preventDefault();
                    console.log('Individual form submission prevented in Add All mode');
                    return false;
                }
                e.preventDefault();
                var $quickAddSubmit = $form.find(".quick-add-submit");
                if ($quickAddSubmit.length && waitsForQuantity($quickAddSubmit[0])) return;
                console.log("Form submitted");
                // Get current basket data
                var basketData = window.BasketManager ? window.BasketManager.data : currentBasketData;
                // Process form to determine changes
                var changes = processFormSelects($form, basketData);
                if (!changes.hasChanges) {
                    showNoChangesMessage($form);
                    return;
                }
                // Disable submit button and show loading state
                var $submitButton = $form.find('button[type="submit"], button.push_button');
                var originalButtonText = $submitButton.text();
                $submitButton.prop('disabled', true).text('Processing...');
                // Execute cart updates
                executeCartUpdates(changes.ticketsToAdd, changes.ticketsToRemove, changes.passesToAdd, changes.passesToRemove, changes.membershipsToAdd, changes.membershipsToRemove, changes.reservedToAdd).then(function(responses) {
                    console.log("Update responses:", responses);
                    // Check if form has redirect_to input
                    var $redirectInput = $form.find('input[name="redirect_to"]');
                    if ($redirectInput.length && $redirectInput.val()) {
                        var redirectUrl = $redirectInput.val();
                        console.log("Redirecting to:", redirectUrl);
                        window.location.href = redirectUrl;
                        return;
                    }
                    // Check if form has BYOT success message flag
                    var $byotFlag = $form.find('input[name="byot_success_message"]');
                    if ($byotFlag.length) {
                        console.log("BYOT success message mode");
                        // Remove the submit button
                        $submitButton.remove();
                        // Build custom BYOT success markup
                        $form.find(".success, .info, .error").remove();
                        if ($byotFlag.val() == 'byot' || $byotFlag.val() == 'subsidized') $form.append('<p class="success" style="margin-top: 1rem;">Pass successfully added to cart.</p><div class="passes-banner passes-banner-plain"><p><strong>Your ' + ($byotFlag.val() === 'byot' ? 'Build-Your-Own-Track Industry Pass' : 'Pass') + ' gives you 20% off individual show tickets.</strong> Discount applied at checkout.</p>' + '<a href="/#program" class="button">Browse shows</a>' + '<p style="margin: 15px 0 15px">Need more time to pick shows? No problem: Once you\'ve purchased your pass, simply sign in to your account and your 20% discount will apply at checkout.</p>' + '<a href="/ticketing/cart/" class="button">Go to Cart</a>' + '</div>');
                        else $form.append('<p class="success" style="margin-top: 1rem;">Pass successfully added to cart.</p><div class="passes-banner passes-banner-plain"><p><strong>Check out now or Browse Shows to make the most of the festival.</strong></p><a href="/#program" class="button">Browse shows</a><p style="margin: 15px 0 15px">Need more time to pick shows? No problem: Once you\'ve purchased your pass, simply sign in to your account choose your shows and checkout.</p><a href="/ticketing/cart/" class="button">Go to Cart</a></div>');
                        // Hide the already-in-cart warning for BYOT success
                        $form.find('[data-already-in-cart]').hide();
                        // Refresh basket data
                        refreshFormsAfterUpdate(responses, $form).then(function(data) {
                            currentBasketData = data;
                            // Keep warning hidden even after refresh
                            $form.find('[data-already-in-cart]').hide();
                        });
                        return;
                    }
                    // Build and display regular success message
                    var message = buildSuccessMessage(changes.ticketsToAdd, changes.ticketsToRemove, changes.passesToAdd, changes.passesToRemove, changes.membershipsToAdd, changes.membershipsToRemove, changes.reservedToAdd);
                    $form.find(".success, .info, .error").remove();
                    $form.append('<p class="success" style="margin-top: 1rem;">' + message.trim() + cartLink() + // A quick-add has its own Quick Buy beside Update Cart.
                    ($instantBuy.length ? "" : oneClickBuyButton()) + '</p>');
                    // Refresh forms after update
                    refreshFormsAfterUpdate(responses, $form).then(function(data) {
                        currentBasketData = data;
                        // Re-enable button - text will be updated by populateExistingQuantities
                        $submitButton.prop('disabled', false);
                    });
                }).catch(function(error) {
                    // Re-enable button and restore original text on error
                    $submitButton.prop('disabled', false).text(originalButtonText);
                    handleCartError(error, $form);
                });
            });
        });
    }
    // A cart changed elsewhere, e.g. checked out by One-Click Buy
    // (js/one-click-buy/App.tsx), with the refreshed basket: the forms count
    // it again.
    document.addEventListener("push:basket", function(event) {
        var basketData = event.detail;
        var ticketCounts = countTicketsInBasket(basketData);
        var passCounts = countPassesInBasket(basketData);
        var membershipCounts = countMembershipsInBasket(basketData);
        $(".tickets-form").each(function() {
            var $form = $(this);
            $form.find(".success, .info, .error").remove();
            populateExistingQuantities($form, ticketCounts, passCounts, membershipCounts, basketData);
        });
    });
    // Initialize forms on page load
    initSpektrixForms();
    // Make function available for external modules
    window.initSpektrixForms = initSpektrixForms;
});


// Component should have a .sidescroll class at the top level,
// with a .sidescroll-list class for the scrollable content.
// Import the twig partial outside of the sidescroll list
const $f8a94df2488dba43$var$sidescrollers = [
    ...document.querySelectorAll(".sidescroll")
];
const $f8a94df2488dba43$var$setupSidescrollers = ()=>{
    if ($f8a94df2488dba43$var$sidescrollers.length === 0) return;
    $f8a94df2488dba43$var$sidescrollers.forEach((sidescroller)=>{
        const sidescrollList = sidescroller.querySelector(".sidescroll-list");
        const scrollbar = sidescroller.querySelector(".sidescroll-scrollbar");
        const bar = scrollbar?.querySelector(".scrollbar-bar");
        function updateVisibility() {
            if (!sidescrollList) return;
            if (sidescrollList.scrollWidth <= sidescrollList.clientWidth) scrollbar.style.display = "none";
            else scrollbar.style.display = "";
        }
        function updateSidescrollScrollbar() {
            const list = sidescroller.querySelector(".sidescroll-list");
            if (!list || !bar || !scrollbar) return;
            const scrollbarWidth = scrollbar.offsetWidth;
            const padding = 16;
            const trackWidth = scrollbarWidth - 2 * padding;
            const scrollLeft = list.scrollLeft;
            const scrollWidth = list.scrollWidth;
            const clientWidth = list.clientWidth;
            const progress = scrollLeft / (scrollWidth - clientWidth);
            const barWidth = Math.max(0, clientWidth / scrollWidth * trackWidth);
            const barLeft = progress * (trackWidth - barWidth);
            bar.style.width = `${barWidth}px`;
            bar.style.transform = `translateX(${barLeft}px)`;
        }
        // Show/hide before sizing: hidden bar measures 0, prevents layout shift.
        function runUpdates() {
            updateVisibility();
            updateSidescrollScrollbar();
        }
        if (sidescrollList) {
            sidescrollList.addEventListener("scroll", updateSidescrollScrollbar);
            // Wait for all images to load before updating
            const images = Array.from(sidescrollList.querySelectorAll("img"));
            let loadedCount = 0;
            const totalImages = images.length;
            if (totalImages === 0) runUpdates();
            images.forEach((img)=>{
                if (img.complete) {
                    loadedCount++;
                    if (loadedCount === totalImages) runUpdates();
                } else img.addEventListener("load", ()=>{
                    loadedCount++;
                    if (loadedCount === totalImages) runUpdates();
                });
            });
        }
        window.addEventListener("resize", runUpdates);
    });
};
$f8a94df2488dba43$var$setupSidescrollers();


function $2cf1f2a36e0f3a2d$var$initListSharing() {
    const listSharingBtns = document.querySelectorAll("button[data-listing-share]");
    if (listSharingBtns.length === 0) return;
    listSharingBtns.forEach((subscribeButton)=>{
        if (!navigator.share) {
            subscribeButton.style.display = "none";
            return;
        }
        subscribeButton.addEventListener("click", ()=>{
            const shareUrl = window.location.href;
            const shareText = "Check out the shows on PuSh this year!\n" + shareUrl;
            navigator.share({
                title: "PuSh Festival",
                text: shareText
            }).then(()=>console.log("Successful share")).catch((error)=>console.log("Error sharing", error));
        });
    });
}
$2cf1f2a36e0f3a2d$var$initListSharing();



// The show's buy bar (push-show.php) slides up once the facts panel,
// .show-header-info, has scrolled out of view above, and back down when it
// returns. It also steps aside while Showtimes & Tickets (its heading and
// forms) is on screen, as it would only repeat that section and cover its
// rows: once the section's top is a quarter of the way up the view, until its
// end is in the top quarter. The view is the window, or the pop-up's
// scroller. The same markup runs on the show page and in the Shortlist pop-up.
//
// It follows scroll position rather than an IntersectionObserver: the panel
// can start below the first screen (a tall photo), and a jump past it (an
// anchor link, or a restored scroll) never crosses an observer threshold.
const $f452c7eecc2e31a5$var$watched = new Map();
// The nearest scrolling ancestor in the flat tree, through the Shortlist
// widget's slot and shadow root; null means the window.
function $f452c7eecc2e31a5$var$scroller(node) {
    let current = node;
    while(current){
        const next = current.assignedSlot ?? current.parentElement ?? (current.getRootNode().host || null);
        if (!next || next === document.documentElement || next === document.body) return null;
        const overflow = getComputedStyle(next).overflowY;
        if (overflow === "auto" || overflow === "scroll") return next;
        current = next;
    }
    return null;
}
function $f452c7eecc2e31a5$var$bindBuybar(bar) {
    if ($f452c7eecc2e31a5$var$watched.has(bar)) return;
    const article = bar.closest("article.show");
    const info = article?.querySelector(".show-header-info");
    if (!article || !info) return;
    // The heading's class, not its id: the Shortlist pop-up prefixes ids.
    const tickets = article.querySelector("h3.tickets");
    const forms = article.querySelectorAll(".tickets-form-content");
    const ticketsEnd = forms.length ? forms[forms.length - 1] : tickets;
    const scroll = $f452c7eecc2e31a5$var$scroller(bar);
    const target = scroll ?? window;
    let frame = 0;
    const update = ()=>{
        frame = 0;
        const view = scroll?.getBoundingClientRect();
        const top = view ? view.top : 0;
        const bottom = view ? view.bottom : window.innerHeight;
        const quarter = (bottom - top) / 4;
        const onTickets = !!tickets && !!ticketsEnd && tickets.getBoundingClientRect().top < bottom - quarter && ticketsEnd.getBoundingClientRect().bottom > top + quarter;
        bar.classList.toggle("is-visible", info.getBoundingClientRect().bottom < top && !onTickets);
    };
    const schedule = ()=>{
        if (!frame) frame = requestAnimationFrame(update);
    };
    target.addEventListener("scroll", schedule, {
        passive: true
    });
    window.addEventListener("resize", schedule, {
        passive: true
    });
    update();
    $f452c7eecc2e31a5$var$watched.set(bar, ()=>{
        cancelAnimationFrame(frame);
        target.removeEventListener("scroll", schedule);
        window.removeEventListener("resize", schedule);
    });
}
function $f452c7eecc2e31a5$export$edf271de5ef55fac(root = document) {
    if (root instanceof HTMLElement && root.matches(".show-buybar")) $f452c7eecc2e31a5$var$bindBuybar(root);
    root.querySelectorAll(".show-buybar").forEach($f452c7eecc2e31a5$var$bindBuybar);
}
// Pop-up shows come and go: bind bars as they arrive (the widget slots the
// show in after the dialog is open, so its scroller exists), release them
// as they leave.
function $f452c7eecc2e31a5$var$watchForInserted() {
    new MutationObserver((records)=>{
        let removed = false;
        records.forEach((record)=>{
            if (record.removedNodes.length) removed = true;
            record.addedNodes.forEach((node)=>{
                if (node instanceof Element) $f452c7eecc2e31a5$export$edf271de5ef55fac(node);
            });
        });
        if (!removed) return;
        $f452c7eecc2e31a5$var$watched.forEach((release, bar)=>{
            if (bar.isConnected) return;
            release();
            $f452c7eecc2e31a5$var$watched.delete(bar);
        });
    }).observe(document.body, {
        childList: true,
        subtree: true
    });
}
$f452c7eecc2e31a5$export$edf271de5ef55fac();
if (document.body) $f452c7eecc2e31a5$var$watchForInserted();
else document.addEventListener("DOMContentLoaded", $f452c7eecc2e31a5$var$watchForInserted);


// The Shortlist's count in the box office tray (inc/box-office-subnav.php),
// styled like the cart's. The widget sends shortlist:updated with the active
// list's shows whenever it changes, pending adds and removes included.
document.addEventListener("shortlist:updated", (event)=>{
    const slugs = event.detail?.slugs ?? [];
    document.querySelectorAll(".js-shortlist-count").forEach((count)=>{
        const number = count.querySelector(".js-shortlist-count-number");
        if (number) number.textContent = String(slugs.length);
        count.hidden = slugs.length === 0;
    });
});


// Newsletter images scroll animation
jQuery(function($) {
    // Use a lower threshold on mobile/smaller viewports to handle cases where section is taller than viewport
    const isMobile = window.innerWidth < 768;
    const threshold = 0.3333;
    const rootMargin = isMobile ? '0px 0px 0px 0px' : '0px 0px -50px 0px';
    const observerOptions = {
        root: null,
        rootMargin: rootMargin,
        threshold: threshold
    };
    // const observer = new IntersectionObserver((entries) => {
    //   entries.forEach(entry => {
    //     if (entry.isIntersecting) {
    //       // Add animated class with a slight delay when section comes into view
    //       setTimeout(() => {
    //         entry.target.classList.add('newsletter-animated');
    //         // Add hover-enabled class after animation completes (750ms delay + 700ms animation)
    //         setTimeout(() => {
    //           entry.target.classList.add('newsletter-hover-enabled');
    //         }, 1450);
    //       }, 50);
    //     } else {
    //       // Remove both classes when section goes out of view
    //       entry.target.classList.remove('newsletter-animated');
    //       entry.target.classList.remove('newsletter-hover-enabled');
    //     }
    //   });
    // }, observerOptions);
    // Observe the newsletter signup section
    const newsletterSection = document.querySelector('.newsletter-signup');
    if (newsletterSection) {
        //   observer.observe(newsletterSection);
        // Just show on load.
        newsletterSection.classList.add('newsletter-animated');
        // Add hover-enabled class after animation completes (750ms delay + 700ms animation)
        setTimeout(()=>{
            newsletterSection.classList.add('newsletter-hover-enabled');
        }, 1450);
    }
});


/**
 * Audio Recorder Widget
 *
 * Integrates with Gravity Forms file upload fields.
 * Only initializes if .audio-recorder-widget exists on the page.
 */ // Configuration — form IDs come from theme (PUSH_AUDIO_FORM_IDS in functions.php).
const $80ff2e5a2431d199$var$GRAVITY_FORM_FILE_INPUT_SELECTOR = 'input[type="file"][name*="input_"]';
const $80ff2e5a2431d199$var$RECORD_DURATION = 30;
const $80ff2e5a2431d199$var$AUDIO_FORM_IDS = Array.isArray(window.PUSH_AUDIO_FORM_IDS) ? window.PUSH_AUDIO_FORM_IDS.map(Number).filter((id)=>id > 0) : [];
const $80ff2e5a2431d199$var$TEXT_REVIEW_FIELD_SELECTOR = $80ff2e5a2431d199$var$AUDIO_FORM_IDS.map((id)=>`#field_${id}_2`).join(", ");
function $80ff2e5a2431d199$var$debugLog(...args) {
    console.log("[audio-recorder]", ...args);
}
/**
 * Track an event with Fathom Analytics (if available)
 * @param eventName - Name of the event to track
 * @param value - Optional value in cents (for monetary tracking)
 */ function $80ff2e5a2431d199$var$trackEvent(eventName, value) {
    if (typeof window.fathom?.trackEvent === "function") {
        if (value !== undefined) window.fathom.trackEvent(eventName, {
            _value: value
        });
        else window.fathom.trackEvent(eventName);
    }
}
let $80ff2e5a2431d199$var$recordRtcLoading = null;
function $80ff2e5a2431d199$var$loadRecordRtc() {
    if (typeof RecordRTC !== "undefined") return Promise.resolve();
    if ($80ff2e5a2431d199$var$recordRtcLoading) return $80ff2e5a2431d199$var$recordRtcLoading;
    $80ff2e5a2431d199$var$recordRtcLoading = new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/recordrtc@5.6.2/RecordRTC.min.js";
        script.onload = ()=>resolve();
        script.onerror = ()=>reject(new Error("Failed to load RecordRTC"));
        document.head.appendChild(script);
    });
    return $80ff2e5a2431d199$var$recordRtcLoading;
}
function $80ff2e5a2431d199$export$623650593fe6802f() {
    const widgets = document.querySelectorAll(".audio-recorder-widget:not([data-arw-initialized])");
    $80ff2e5a2431d199$var$debugLog("initAudioRecorder", {
        widgetCount: widgets.length
    });
    if (!widgets.length) return;
    $80ff2e5a2431d199$var$loadRecordRtc().then(()=>{
        widgets.forEach((widget)=>{
            widget.setAttribute("data-arw-initialized", "true");
            $80ff2e5a2431d199$var$setupRecorder(widget);
        });
    }).catch((err)=>{
        console.warn("Audio recorder: RecordRTC load failed", err);
    });
}
function $80ff2e5a2431d199$var$setupRecorder(widget) {
    const state = {
        recorder: null,
        stream: null,
        audioContext: null,
        analyser: null,
        animationId: null,
        timerInterval: null,
        timeRemaining: $80ff2e5a2431d199$var$RECORD_DURATION,
        isRecording: false,
        audioBlob: null
    };
    // Get DOM elements
    const recordBtn = widget.querySelector("#arwRecordBtn");
    const timer = widget.querySelector("#arwTimer");
    const status = widget.querySelector("#arwStatus");
    const progress = widget.querySelector("#arwProgress");
    const playback = widget.querySelector("#arwPlayback");
    const audioPlayer = widget.querySelector("#arwAudioPlayer");
    const reRecordBtn = widget.querySelector("#arwReRecord");
    const visualizer = widget.querySelector("#arwVisualizer");
    const mainUI = widget.querySelector("#arwMain");
    const unsupportedUI = widget.querySelector("#arwUnsupported");
    if (!recordBtn || !timer || !status || !progress || !playback || !audioPlayer || !reRecordBtn || !visualizer || !mainUI || !unsupportedUI) {
        console.warn("Audio recorder: Missing required DOM elements");
        return;
    }
    const ctx = visualizer.getContext("2d");
    if (!ctx) return;
    // Check browser support
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        mainUI.style.display = "none";
        unsupportedUI.style.display = "block";
        return;
    }
    function getFileInput() {
        const form = widget.closest("form");
        if (form) return form.querySelector($80ff2e5a2431d199$var$GRAVITY_FORM_FILE_INPUT_SELECTOR);
        return document.querySelector($80ff2e5a2431d199$var$GRAVITY_FORM_FILE_INPUT_SELECTOR);
    }
    function resizeCanvas() {
        const rect = visualizer.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        visualizer.width = rect.width * dpr;
        visualizer.height = rect.height * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function getCanvasSize() {
        const dpr = window.devicePixelRatio || 1;
        return {
            width: visualizer.width / dpr,
            height: visualizer.height / dpr
        };
    }
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    }
    function updateProgress(remaining) {
        const elapsed = $80ff2e5a2431d199$var$RECORD_DURATION - remaining;
        const percent = elapsed / $80ff2e5a2431d199$var$RECORD_DURATION * 100;
        progress.style.width = percent + "%";
    }
    function drawVisualizer() {
        const { width: width, height: height } = getCanvasSize();
        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, width, height);
        if (state.analyser && state.isRecording) {
            const bufferLength = state.analyser.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            state.analyser.getByteFrequencyData(dataArray);
            const barWidth = width / bufferLength * 2.5;
            let x = 0;
            for(let i = 0; i < bufferLength; i++){
                const barHeight = dataArray[i] / 255 * height * 0.8;
                if (barHeight > 0) {
                    ctx.fillStyle = "#E94213";
                    ctx.fillRect(x, height - barHeight, barWidth - 1, barHeight);
                }
                x += barWidth;
            }
        }
        if (state.isRecording) state.animationId = requestAnimationFrame(drawVisualizer);
    }
    function drawIdleVisualizer() {
        const { width: width, height: height } = getCanvasSize();
        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, width, height);
        ctx.beginPath();
        ctx.strokeStyle = "#e0e0e0";
        ctx.lineWidth = 1;
        ctx.moveTo(0, height / 2);
        ctx.lineTo(width, height / 2);
        ctx.stroke();
    }
    function attachToGravityForms(blob) {
        const fileInput = getFileInput();
        if (!fileInput) {
            $80ff2e5a2431d199$var$debugLog("file input not found for attach");
            console.warn("Gravity Forms file input not found. Selector:", $80ff2e5a2431d199$var$GRAVITY_FORM_FILE_INPUT_SELECTOR);
            status.textContent = "Recording ready! (Manual upload may be required)";
            status.classList.add("arw-status--success");
            return false;
        }
        const fileName = `testimonial-${Date.now()}.wav`;
        const file = new File([
            blob
        ], fileName, {
            type: "audio/wav"
        });
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;
        fileInput.dispatchEvent(new Event("change", {
            bubbles: true
        }));
        // Mark that audio was attached (used for submission tracking)
        document.body.setAttribute("data-audio-recording-attached", "true");
        $80ff2e5a2431d199$var$debugLog("audio attached to file input", {
            fileName: fileName,
            size: blob.size
        });
        status.textContent = "Recording captured!";
        status.classList.remove("arw-status--error");
        status.classList.add("arw-status--success");
        return true;
    }
    async function startRecording() {
        try {
            resizeCanvas();
            state.stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true
                }
            });
            // Set up audio context for visualization
            const AudioContextClass = window.AudioContext || window.webkitAudioContext;
            state.audioContext = new AudioContextClass();
            if (state.audioContext.state === "suspended") await state.audioContext.resume();
            state.analyser = state.audioContext.createAnalyser();
            const source = state.audioContext.createMediaStreamSource(state.stream);
            source.connect(state.analyser);
            state.analyser.fftSize = 256;
            // Create RecordRTC recorder - outputs WAV
            state.recorder = new RecordRTC(state.stream, {
                type: "audio",
                mimeType: "audio/wav",
                recorderType: RecordRTC.StereoAudioRecorder,
                numberOfAudioChannels: 1,
                desiredSampRate: 44100
            });
            state.recorder.startRecording();
            state.isRecording = true;
            // Track recording started
            $80ff2e5a2431d199$var$trackEvent("Audio Recording Started");
            recordBtn.classList.add("arw-record-btn--recording");
            timer.classList.add("arw-timer--recording");
            progress.classList.add("arw-progress-fill--recording");
            status.textContent = "Recording...";
            status.classList.remove("arw-status--error", "arw-status--success");
            playback.classList.remove("arw-playback--visible");
            drawVisualizer();
            state.timeRemaining = $80ff2e5a2431d199$var$RECORD_DURATION;
            timer.textContent = formatTime(state.timeRemaining);
            updateProgress(state.timeRemaining);
            state.timerInterval = window.setInterval(()=>{
                state.timeRemaining--;
                timer.textContent = formatTime(state.timeRemaining);
                updateProgress(state.timeRemaining);
                if (state.timeRemaining <= 0) stopRecording();
            }, 1000);
        } catch (err) {
            console.error("Microphone error:", err);
            let errorMessage = "Unable to access microphone.";
            let errorType = "access_denied";
            if (err.name === "NotFoundError") {
                errorMessage = "Could not access microphone.";
                errorType = "not_found";
            } else if (err.name === "NotReadableError") {
                errorMessage = "Microphone is in use by another app.";
                errorType = "in_use";
            }
            // Track recording error
            $80ff2e5a2431d199$var$trackEvent(`Audio Recording Error - ${errorType}`);
            status.textContent = errorMessage;
            status.classList.add("arw-status--error");
        }
    }
    function stopRecording() {
        if (state.recorder && state.isRecording) state.recorder.stopRecording(()=>{
            state.audioBlob = state.recorder.getBlob();
            console.log("Recording complete. Type:", state.audioBlob?.type, "Size:", state.audioBlob?.size);
            if (state.audioBlob) {
                const audioUrl = URL.createObjectURL(state.audioBlob);
                audioPlayer.src = audioUrl;
                playback.classList.add("arw-playback--visible");
                // Track recording completed with duration (in seconds, passed as cents for Fathom)
                const durationRecorded = $80ff2e5a2431d199$var$RECORD_DURATION - state.timeRemaining;
                $80ff2e5a2431d199$var$trackEvent("Audio Recording Completed", durationRecorded * 100);
                attachToGravityForms(state.audioBlob);
            }
        });
        if (state.stream) {
            state.stream.getTracks().forEach((track)=>track.stop());
            state.stream = null;
        }
        if (state.audioContext) {
            state.audioContext.close();
            state.audioContext = null;
            state.analyser = null;
        }
        if (state.animationId) {
            cancelAnimationFrame(state.animationId);
            state.animationId = null;
        }
        if (state.timerInterval) {
            clearInterval(state.timerInterval);
            state.timerInterval = null;
        }
        state.isRecording = false;
        recordBtn.classList.remove("arw-record-btn--recording");
        timer.classList.remove("arw-timer--recording");
        // progress.classList.remove('arw-progress-fill--recording');
        timer.textContent = formatTime($80ff2e5a2431d199$var$RECORD_DURATION);
        // progress.style.width = '0%';
        drawIdleVisualizer();
    }
    function resetRecorder() {
        // Track re-record action
        $80ff2e5a2431d199$var$trackEvent("Audio Recording Re-record");
        playback.classList.remove("arw-playback--visible");
        audioPlayer.src = "";
        state.audioBlob = null;
        status.textContent = "Tap to start recording";
        status.classList.remove("arw-status--error", "arw-status--success");
        // Clear the audio attached flag
        document.body.removeAttribute("data-audio-recording-attached");
        const fileInput = getFileInput();
        if (fileInput) {
            fileInput.value = "";
            fileInput.dispatchEvent(new Event("change", {
                bubbles: true
            }));
        }
        drawIdleVisualizer();
    }
    // Initialize
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);
    recordBtn.addEventListener("click", ()=>{
        if (state.isRecording) stopRecording();
        else startRecording();
    });
    reRecordBtn.addEventListener("click", resetRecorder);
    drawIdleVisualizer();
    $80ff2e5a2431d199$var$debugLog("recorder setup complete for widget");
}
window.pushInitAudioRecorder = $80ff2e5a2431d199$export$623650593fe6802f;
// Initialize when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $80ff2e5a2431d199$export$623650593fe6802f);
else $80ff2e5a2431d199$export$623650593fe6802f();
document.addEventListener("gform/post_render", (event)=>{
    const formId = event.detail?.formId;
    $80ff2e5a2431d199$var$debugLog("gform/post_render", {
        formId: formId,
        audioFormIds: $80ff2e5a2431d199$var$AUDIO_FORM_IDS
    });
    if ($80ff2e5a2431d199$var$AUDIO_FORM_IDS.includes(Number(formId))) $80ff2e5a2431d199$export$623650593fe6802f();
});
jQuery(document).ready(function($) {
    // Toggle text comment
    $(document).on("click", ".js-text-comment", function(e) {
        e.preventDefault();
        const $form = $(this).closest("form");
        const $field = $form.length ? $form.find($80ff2e5a2431d199$var$TEXT_REVIEW_FIELD_SELECTOR).first() : $($80ff2e5a2431d199$var$TEXT_REVIEW_FIELD_SELECTOR).first();
        $80ff2e5a2431d199$var$debugLog("text comment toggle", {
            found: $field.length > 0,
            formId: $form.attr("data-formid") || $form.attr("id")
        });
        if (!$field.length) return false;
        $field.slideToggle(function() {
            if ($field.find("textarea").is(":visible")) {
                $field.find("textarea").focus();
                $80ff2e5a2431d199$var$trackEvent("Testimonial Text Comment Opened");
            }
        });
        return false;
    });
    // Track form submission - with or without audio
    $(document).on("gform_confirmation_loaded", function(event, formId) {
        $80ff2e5a2431d199$var$debugLog("gform_confirmation_loaded", {
            formId: formId
        });
        // Check if this form had an audio recording attached
        // We use a data attribute set when audio is attached since the form may be replaced
        const hasAudio = document.body.getAttribute("data-audio-recording-attached") === "true";
        if (hasAudio) $80ff2e5a2431d199$var$trackEvent("Testimonial Submitted - With Audio");
        else $80ff2e5a2431d199$var$trackEvent("Testimonial Submitted - Without Audio");
        // Clean up the flag
        document.body.removeAttribute("data-audio-recording-attached");
    });
});


const $60c1dd6d36a26e56$var$BAR_COUNT = 64;
const $60c1dd6d36a26e56$var$PLAYED_COLOR = "#E94213";
const $60c1dd6d36a26e56$var$IDLE_COLOR = "#ffffff";
const $60c1dd6d36a26e56$var$formatTime = (seconds)=>{
    if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
};
const $60c1dd6d36a26e56$var$peaksFromChannelData = (data, barCount)=>{
    const blockSize = Math.floor(data.length / barCount) || 1;
    const peaks = [];
    for(let i = 0; i < barCount; i++){
        const start = i * blockSize;
        let max = 0;
        for(let j = 0; j < blockSize && start + j < data.length; j++){
            const v = Math.abs(data[start + j]);
            if (v > max) max = v;
        }
        peaks.push(max);
    }
    const peakMax = Math.max(...peaks, 0.01);
    return peaks.map((p)=>p / peakMax);
};
const $60c1dd6d36a26e56$var$fallbackPeaks = (barCount, seed)=>{
    const peaks = [];
    let s = seed || 1;
    for(let i = 0; i < barCount; i++){
        s = s * 16807 % 2147483647;
        const t = i / barCount;
        const envelope = 0.35 + 0.65 * Math.sin(Math.PI * t);
        peaks.push(envelope * (0.25 + s % 1000 / 1000));
    }
    return peaks;
};
const $60c1dd6d36a26e56$var$loadPeaks = async (url)=>{
    try {
        const res = await fetch(url);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const arrayBuffer = await res.arrayBuffer();
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        const ctx = new AudioCtx();
        const audioBuffer = await ctx.decodeAudioData(arrayBuffer.slice(0));
        const channel = audioBuffer.getChannelData(0);
        const peaks = $60c1dd6d36a26e56$var$peaksFromChannelData(channel, $60c1dd6d36a26e56$var$BAR_COUNT);
        ctx.close();
        return {
            peaks: peaks,
            duration: audioBuffer.duration
        };
    } catch  {
        return {
            peaks: $60c1dd6d36a26e56$var$fallbackPeaks($60c1dd6d36a26e56$var$BAR_COUNT, url.length),
            duration: 0
        };
    }
};
const $60c1dd6d36a26e56$var$audioLabel = (card, playing)=>{
    const name = card.getAttribute("data-audio-label")?.trim() ?? "";
    const verb = playing ? "Pause" : "Play";
    return name !== "" ? `${verb} audio from ${name}` : `${verb} audio`;
};
const $60c1dd6d36a26e56$var$setupTestimonials = ()=>{
    const cards = document.querySelectorAll("[data-audio-player]");
    if (cards.length === 0) return;
    let activeAudio = null;
    let activeSetPlaying = null;
    let activeStopDraw = null;
    const pauseActive = ()=>{
        if (!activeAudio) return;
        activeAudio.pause();
        activeSetPlaying?.(false);
        activeStopDraw?.();
        activeAudio = null;
        activeSetPlaying = null;
        activeStopDraw = null;
    };
    cards.forEach((card)=>{
        const audio = card.querySelector("audio");
        const playBtn = card.querySelector("[data-audio-play]");
        const toggleBtn = card.querySelector("[data-audio-transcript-toggle]");
        const transcript = card.querySelector("[data-audio-transcript]");
        const canvas = card.querySelector("[data-audio-visualizer]");
        const timeCurrent = card.querySelector('[data-audio-time="current"]');
        const timeDuration = card.querySelector('[data-audio-time="duration"]');
        let peaks = $60c1dd6d36a26e56$var$fallbackPeaks($60c1dd6d36a26e56$var$BAR_COUNT, 1);
        let rafId = 0;
        const setPlaying = (playing)=>{
            if (!playBtn) return;
            playBtn.setAttribute("aria-pressed", playing ? "true" : "false");
            playBtn.classList.toggle("is-playing", playing);
            playBtn.setAttribute("aria-label", $60c1dd6d36a26e56$var$audioLabel(card, playing));
        };
        const setTranscriptOpen = (open)=>{
            if (!transcript || !toggleBtn) return;
            card.classList.toggle("testimonial--transcript-open", open);
            transcript.hidden = !open;
            toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
            toggleBtn.textContent = open ? "Close Transcript" : "View Transcript";
        };
        const resizeCanvas = ()=>{
            if (!canvas) return;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            const rect = canvas.getBoundingClientRect();
            const dpr = window.devicePixelRatio || 1;
            canvas.width = Math.max(1, Math.floor(rect.width * dpr));
            canvas.height = Math.max(1, Math.floor(rect.height * dpr));
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };
        const draw = (progress = 0)=>{
            if (!canvas) return;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            const dpr = window.devicePixelRatio || 1;
            const width = canvas.width / dpr;
            const height = canvas.height / dpr;
            if (width <= 0 || height <= 0) return;
            ctx.clearRect(0, 0, width, height);
            const count = peaks.length;
            const gap = 1;
            const barWidth = Math.max(1, (width - gap * (count - 1)) / count);
            const midY = height / 2;
            const maxHalf = height * 0.45;
            const playedColor = getComputedStyle(canvas).getPropertyValue("--waveform-played").trim() || $60c1dd6d36a26e56$var$PLAYED_COLOR;
            for(let i = 0; i < count; i++){
                const x = i * (barWidth + gap);
                const half = Math.max(1, peaks[i] * maxHalf);
                const played = i / count < progress;
                ctx.fillStyle = played ? playedColor : $60c1dd6d36a26e56$var$IDLE_COLOR;
                ctx.fillRect(x, midY - half, barWidth, half * 2);
            }
        };
        const updateTime = ()=>{
            if (!audio) return;
            if (timeCurrent) timeCurrent.textContent = $60c1dd6d36a26e56$var$formatTime(audio.currentTime);
            const duration = Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : 0;
            if (timeDuration && duration) timeDuration.textContent = $60c1dd6d36a26e56$var$formatTime(duration);
        };
        const stopDrawLoop = ()=>{
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = 0;
            }
            draw(audio && audio.duration ? audio.currentTime / audio.duration : 0);
        };
        const startDrawLoop = ()=>{
            const tick = ()=>{
                if (!audio || audio.paused) return;
                const progress = audio.duration ? audio.currentTime / audio.duration : 0;
                draw(progress);
                updateTime();
                rafId = requestAnimationFrame(tick);
            };
            stopDrawLoop();
            rafId = requestAnimationFrame(tick);
        };
        if (canvas && audio?.src) {
            resizeCanvas();
            draw(0);
            $60c1dd6d36a26e56$var$loadPeaks(audio.src).then(({ peaks: loaded, duration: duration })=>{
                peaks = loaded;
                if (duration && timeDuration) timeDuration.textContent = $60c1dd6d36a26e56$var$formatTime(duration);
                resizeCanvas();
                draw(0);
            });
            audio.addEventListener("loadedmetadata", updateTime);
            window.addEventListener("resize", ()=>{
                resizeCanvas();
                const progress = audio && !audio.paused && audio.duration ? audio.currentTime / audio.duration : audio?.duration ? audio.currentTime / audio.duration : 0;
                draw(progress);
            });
        }
        playBtn?.addEventListener("click", async ()=>{
            if (!audio) return;
            if (audio.paused) {
                if (activeAudio && activeAudio !== audio) pauseActive();
                try {
                    await audio.play();
                    setPlaying(true);
                    startDrawLoop();
                    activeAudio = audio;
                    activeSetPlaying = setPlaying;
                    activeStopDraw = stopDrawLoop;
                } catch  {
                    setPlaying(false);
                    stopDrawLoop();
                    if (activeAudio === audio) {
                        activeAudio = null;
                        activeSetPlaying = null;
                        activeStopDraw = null;
                    }
                }
            } else {
                audio.pause();
                setPlaying(false);
                stopDrawLoop();
                if (activeAudio === audio) {
                    activeAudio = null;
                    activeSetPlaying = null;
                    activeStopDraw = null;
                }
            }
        });
        audio?.addEventListener("ended", ()=>{
            setPlaying(false);
            audio.currentTime = 0;
            stopDrawLoop();
            draw(0);
            updateTime();
            if (activeAudio === audio) {
                activeAudio = null;
                activeSetPlaying = null;
                activeStopDraw = null;
            }
        });
        audio?.addEventListener("pause", ()=>{
            if (audio.ended) return;
            setPlaying(false);
            stopDrawLoop();
            if (activeAudio === audio) {
                activeAudio = null;
                activeSetPlaying = null;
                activeStopDraw = null;
            }
        });
        if (toggleBtn && transcript) toggleBtn.addEventListener("click", ()=>{
            const open = !card.classList.contains("testimonial--transcript-open");
            setTranscriptOpen(open);
        });
    });
};
$60c1dd6d36a26e56$var$setupTestimonials();



var $5IiZx = parcelRequire("5IiZx");

const $dda11eb578f89c49$var$tabsBlocks = document.querySelectorAll("[data-tabs]");
const $dda11eb578f89c49$var$TAB_COOKIE = "program_tab";
function $dda11eb578f89c49$var$initTabs(tabsBlock) {
    if (!tabsBlock) return;
    const tablist = tabsBlock.querySelector("[role='tablist']");
    if (!tablist || tablist.children.length <= 0) return;
    const tabs = tablist.querySelectorAll("button[role='tab']");
    const panels = tabsBlock.querySelectorAll(":scope > [role='tabpanel']");
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const rememberTab = tabsBlock.getAttribute("data-tabs") === "program";
    const saveTab = (tab)=>{
        if (!rememberTab) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).set($dda11eb578f89c49$var$TAB_COOKIE, tab.id, {
            expires: 365
        });
    };
    const getHashId = ()=>decodeURIComponent(window.location.hash.replace(/^#/, ""));
    const syncTabUrl = (tab, initial = false)=>{
        if (!rememberTab) return;
        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (tab.id === "daily") {
            params.delete("types");
            if (!initial && !(0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)(url.hash) && !(0, $1d27541b500be4a6$export$eb69eac63ef3ef40)(url.hash)) url.hash = "program";
        } else {
            const checked = Array.from(document.querySelectorAll('input[name="types[]"]:checked')).map((input)=>input.value);
            if (checked.length > 0) params.set("types", checked.join(","));
            else params.delete("types");
            // On load, only a Daily Schedule day's hash (which this tab doesn't
            // show) becomes #program; other hashes belong to someone else.
            if ((!initial || (0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)(url.hash)) && !(0, $1d27541b500be4a6$export$eb69eac63ef3ef40)(url.hash)) url.hash = "program";
        }
        const next = (0, $1d27541b500be4a6$export$f79e151f0c660df6)(url);
        if (`${window.location.pathname}${window.location.search}${window.location.hash}` !== next) window.history.replaceState(null, document.title, next);
    };
    const showPanel = (panel)=>{
        panel.hidden = false;
        panel.setAttribute("data-tab", "show");
    };
    const hidePanel = (panel)=>{
        panel.hidden = true;
        panel.removeAttribute("data-tab");
    };
    const scrollToDay = (id, tries = 0)=>{
        const day = document.getElementById(id);
        const panel = document.getElementById("daily-panel");
        if (!day || panel?.hidden || !panel?.hasAttribute("data-tab")) {
            if (tries < 30) requestAnimationFrame(()=>scrollToDay(id, tries + 1));
            return;
        }
        if (day.getBoundingClientRect().height === 0 && tries < 30) {
            requestAnimationFrame(()=>scrollToDay(id, tries + 1));
            return;
        }
        const root = document.documentElement;
        const previousBehavior = root.style.scrollBehavior;
        root.style.scrollBehavior = "auto";
        day.scrollIntoView({
            block: "start",
            behavior: "auto"
        });
        root.style.scrollBehavior = previousBehavior;
    };
    const switchTab = (oldTab, newTab, event)=>{
        if (event instanceof KeyboardEvent) newTab.focus();
        newTab.setAttribute("aria-selected", "true");
        newTab.setAttribute("tabindex", "0");
        oldTab.setAttribute("aria-selected", "false");
        oldTab.setAttribute("tabindex", "-1");
        const newIndex = Array.from(tabs).indexOf(newTab);
        const oldIndex = Array.from(tabs).indexOf(oldTab);
        hidePanel(panels[oldIndex]);
        showPanel(panels[newIndex]);
        saveTab(newTab);
        syncTabUrl(newTab);
        isMobile;
    };
    tabs.forEach((tab, i)=>{
        tab.setAttribute("aria-controls", panels[i].id);
        tab.addEventListener("click", (e)=>{
            e.preventDefault();
            const target = e.currentTarget;
            const currentTab = tablist.querySelector("[aria-selected='true']");
            if (target !== currentTab) switchTab(currentTab, target, e);
            else if (isMobile) tablist.setAttribute("data-mobile-open", "true");
        });
        tab.addEventListener("keydown", (e)=>{
            const target = e.currentTarget;
            const index = Array.from(tabs).indexOf(target);
            const isFirst = index === 0;
            const isLast = index === tabs.length - 1;
            const dir = e.key === "ArrowLeft" ? isFirst ? tabs.length - 1 : index - 1 : e.key === "ArrowRight" ? isLast ? 0 : index + 1 : null;
            if (dir !== null) {
                e.preventDefault();
                switchTab(target, tabs[dir], e);
            }
        });
    });
    panels.forEach((panel, i)=>{
        panel.setAttribute("aria-labelledby", tabs[i].id);
        hidePanel(panel);
    });
    const typesParam = new URLSearchParams(window.location.search).get("types");
    const hasTypes = Boolean(typesParam && typesParam.trim() !== "");
    const getInitialTabIndex = ()=>{
        if (!rememberTab) return 0;
        if (hasTypes) {
            const typesIndex = Array.from(tabs).findIndex((tab)=>tab.id === "all-shows");
            return typesIndex >= 0 ? typesIndex : 0;
        }
        const hash = getHashId();
        if ((0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)(hash)) {
            const dailyIndex = Array.from(tabs).findIndex((tab)=>tab.id === "daily");
            return dailyIndex >= 0 ? dailyIndex : 0;
        }
        const storedId = (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).get($dda11eb578f89c49$var$TAB_COOKIE);
        const storedIndex = storedId ? Array.from(tabs).findIndex((tab)=>tab.id === storedId) : -1;
        return storedIndex >= 0 ? storedIndex : 0;
    };
    const initialTab = getInitialTabIndex();
    tabs.forEach((tab, i)=>{
        const isInitial = i === initialTab;
        tab.setAttribute("aria-selected", isInitial ? "true" : "false");
        tab.setAttribute("tabindex", isInitial ? "0" : "-1");
    });
    showPanel(panels[initialTab]);
    saveTab(tabs[initialTab]);
    syncTabUrl(tabs[initialTab], true);
    const hash = getHashId();
    if (hasTypes && tabs[initialTab].id === "all-shows") requestAnimationFrame(()=>{
        document.getElementById("program")?.scrollIntoView({
            behavior: "auto",
            block: "start"
        });
    });
    else if (tabs[initialTab].id === "daily" && (0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)(hash)) scrollToDay(hash);
    // Links elsewhere on the page to a day (the homepage's Today bar) open the
    // Daily Schedule on that day. The browser can't scroll to a day while its
    // tab is hidden, and the Shortlist widget answers the popstate a fragment
    // link fires by restoring its own scroll position, so the jump happens here
    // with pushState, as the date chips' does (js/program-dates.ts).
    if (rememberTab) document.addEventListener("click", (event)=>{
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest?.("a[href^='#']");
        const id = link ? decodeURIComponent(link.hash.replace(/^#/, "")) : "";
        const dailyTab = Array.from(tabs).find((tab)=>tab.id === "daily");
        const currentTab = tablist.querySelector("[aria-selected='true']");
        if (!id || !(0, $1d27541b500be4a6$export$9cdf91fbbc5b2bc4)(id) || !dailyTab || !currentTab) return;
        event.preventDefault();
        if (`#${id}` !== window.location.hash) history.pushState(null, "", `#${id}`);
        if (currentTab !== dailyTab) switchTab(currentTab, dailyTab);
        scrollToDay(id);
        const day = document.getElementById(id);
        if (day) {
            day.tabIndex = -1;
            day.focus({
                preventScroll: true
            });
        }
    });
}
$dda11eb578f89c49$var$tabsBlocks.forEach($dda11eb578f89c49$var$initTabs);


// The date bar sticks under the masthead (see sass/content/_daily-schedule.scss).
// The masthead's height changes with the breakpoint, the box office bar and
// wrapping, so it's measured rather than hard-coded.
function $2e3daaa5d9491b11$var$measureMasthead(daily) {
    const masthead = document.getElementById("masthead");
    if (!masthead) return;
    const update = ()=>{
        const position = getComputedStyle(masthead).position;
        const sticks = position === "sticky" || position === "fixed";
        const height = sticks ? Math.round(masthead.getBoundingClientRect().height) : 0;
        daily.style.setProperty("--masthead-height", `${height}px`);
    };
    new ResizeObserver(update).observe(masthead);
    update();
}
// The page cache can serve the schedule a day after it was made (it carries
// that date as data-today): drop the days that have passed since, from the
// schedule, the chips and the calendar, and move Today to the real one.
// A ?today= preview (data-today-preview) keeps its own date.
function $2e3daaa5d9491b11$var$catchUpToToday() {
    const daily = document.querySelector(".program-daily");
    const made = daily?.dataset.today;
    if (!daily || !made || daily.hasAttribute("data-today-preview")) return;
    // en-CA writes dates as YYYY-MM-DD.
    const today = new Intl.DateTimeFormat("en-CA", {
        timeZone: "America/Vancouver"
    }).format(new Date());
    if (today <= made) return;
    daily.dataset.today = today;
    const weekday = (date, length)=>new Date(`${date}T12:00:00`).toLocaleDateString("en-US", {
            weekday: length
        });
    const marked = (date)=>document.querySelectorAll(`[data-date="${date}"]`);
    document.querySelectorAll(".program-daily-day[data-date], .program-filters-chip[data-date]").forEach((node)=>{
        if (node.dataset.date < today) node.remove();
    });
    document.querySelectorAll(".program-calendar-cell[data-date]").forEach((cell)=>{
        const link = cell.querySelector("a");
        if (cell.dataset.date >= today || !link) return;
        const date = cell.dataset.date;
        const day = document.createElement("span");
        const hidden = document.createElement("span");
        hidden.className = "visually-hidden";
        hidden.textContent = `, ${weekday(date, "long")}, ${new Date(`${date}T12:00:00`).toLocaleDateString("en-US", {
            month: "long"
        })} (past)`;
        day.append(link.textContent.trim(), hidden);
        link.replaceWith(day);
        cell.classList.add("is-past");
        if (cell.dataset.label) cell.dataset.label = cell.dataset.label.replace(/^Today,/, `${weekday(date, "short")},`);
    });
    // Today: its tag in the day's heading, the chip's label and aria-current.
    document.querySelectorAll(".program-daily-today").forEach((tag)=>{
        const tags = tag.parentElement;
        tag.remove();
        if (tags && !tags.children.length) tags.remove();
    });
    document.querySelectorAll('.program-daily a[aria-current="date"]').forEach((link)=>{
        link.removeAttribute("aria-current");
        link.setAttribute("aria-label", (link.getAttribute("aria-label") || "").replace(/^Today, /, ""));
        const chip = link.closest(".program-filters-chip");
        const label = chip?.querySelector("strong");
        if (label && chip?.dataset.date) label.textContent = weekday(chip.dataset.date, "short");
    });
    marked(today).forEach((node)=>{
        // The calendar's label for the phone bar ("Today, Jan 23").
        if (node.dataset.label) node.dataset.label = node.dataset.label.replace(/^\w+,/, "Today,");
        const link = node.matches(".program-daily-day") ? null : node.querySelector("a");
        if (link) {
            link.setAttribute("aria-current", "date");
            link.setAttribute("aria-label", `Today, ${link.getAttribute("aria-label") || ""}`);
            const label = link.querySelector("strong");
            if (label) label.textContent = "Today";
            return;
        }
        const heading = node.querySelector(".program-daily-heading");
        if (!heading) return;
        let tags = heading.querySelector(".program-daily-tags");
        if (!tags) {
            tags = document.createElement("p");
            tags.className = "program-daily-tags";
            heading.querySelector("h3")?.after(tags);
        }
        const tag = document.createElement("span");
        tag.className = "program-daily-today";
        tag.textContent = "Today";
        tags.prepend(tag);
    });
    // The phones' Jump to day names the first day left.
    const first = document.querySelector(".program-calendar-cell[data-date]:not(.is-past)");
    const toggleDay = document.querySelector(".program-calendar-toggle-day");
    if (first?.dataset.label && toggleDay) toggleDay.textContent = first.dataset.label;
}
function $2e3daaa5d9491b11$var$initProgramDatesScroll() {
    const daily = document.querySelector(".program-daily");
    const calendar = document.querySelector(".program-calendar");
    const toggle = calendar?.querySelector(".program-calendar-header button");
    const toggleDay = toggle?.querySelector(".program-calendar-toggle-day");
    const calendarContent = calendar?.querySelector(".program-calendar-content");
    const calendarPanel = document.getElementById("program-calendar-panel");
    const nav = document.querySelector(".program-dates");
    const scroller = nav?.querySelector(".program-dates-wrapper");
    const prev = nav?.querySelector(".program-dates-scroll--prev");
    const next = nav?.querySelector(".program-dates-scroll--next");
    const days = document.querySelectorAll(".program-daily-day");
    const chipMq = window.matchMedia("(min-width: 480px)");
    if (!nav && !calendar) return;
    if (daily) $2e3daaa5d9491b11$var$measureMasthead(daily);
    let ignoreSpyUntil = 0;
    let currentDayId = "";
    let closeTimer = null;
    let spyFrame = 0;
    const pauseSpy = (ms = 800)=>{
        ignoreSpyUntil = Date.now() + ms;
    };
    const chipsVisible = ()=>chipMq.matches;
    // Where a day's heading sticks: under the admin bar, masthead and date bar.
    const getStickyOffset = ()=>{
        if (!daily) return 0;
        const probe = daily.querySelector(".program-daily-heading");
        return probe ? parseFloat(getComputedStyle(probe).top) || 0 : 0;
    };
    const getDateBarBottom = ()=>{
        const bar = chipsVisible() ? nav : calendar;
        if (bar && getComputedStyle(bar).display !== "none") return bar.getBoundingClientRect().bottom;
        return getStickyOffset();
    };
    const dayMarker = (day)=>day.querySelector(".program-daily-heading") ?? day;
    // The phone calendar's panel drops down over the page, so the bar's height
    // is the toggle's either way.
    const measureDatepicker = ()=>{
        if (!daily) return;
        const el = chipsVisible() ? nav : calendar;
        const height = el && getComputedStyle(el).display !== "none" ? el.getBoundingClientRect().height : 0;
        if (height > 0) daily.style.setProperty("--date-bar-height", `${Math.round(height)}px`);
    };
    const setCurrentDayById = (id)=>{
        if (!id) return;
        currentDayId = id;
        document.querySelectorAll(".program-calendar-cell.is-current, .program-filters-chip.is-current").forEach((el)=>el.classList.remove("is-current"));
        const cell = calendar?.querySelector(`.program-calendar-cell[data-day="${CSS.escape(id)}"]`);
        cell?.classList.add("is-current");
        // The phone bar names the day in view.
        if (toggleDay && cell?.dataset.label) toggleDay.textContent = cell.dataset.label;
        const chip = nav?.querySelector(`.program-filters-chip[data-day="${CSS.escape(id)}"]`);
        chip?.classList.add("is-current");
        if (!nav || !scroller || !chipsVisible() || !chip) return;
        // The strip tracks the days: each one scrolls it the same share of its
        // overflow, so it sits at the start on the first day (the track's
        // padding lining the chips up with the page's column) and at the end on
        // the last, and the current chip drifts across as the days go by. It
        // never stops under the 4rem fades behind the scroll buttons: a chip
        // there pulls the strip a chip's gap clear of them.
        const chips = Array.from(nav.querySelectorAll(".program-filters-chip"));
        const index = chips.indexOf(chip);
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        const clearance = 4.5 * rem;
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        if (maxScroll <= 0 || index < 0) return;
        const chipOffset = chip.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
        const chipRight = chipOffset + chip.offsetWidth;
        let left = chips.length > 1 ? maxScroll * index / (chips.length - 1) : 0;
        if (index > 0) left = Math.min(left, chipOffset - clearance);
        if (index < chips.length - 1) left = Math.max(left, chipRight - scroller.clientWidth + clearance);
        left = Math.min(maxScroll, Math.max(0, left));
        if (Math.abs(left - scroller.scrollLeft) > 1) scroller.scrollTo({
            left: left,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
        });
    };
    const setCurrentDay = (day)=>{
        if (Date.now() < ignoreSpyUntil) return;
        setCurrentDayById(day.id);
    };
    const pickCurrentDay = ()=>{
        const panel = document.getElementById("daily-panel");
        if (panel?.hidden || days.length === 0) return;
        if (Date.now() < ignoreSpyUntil) return;
        // Offset for scroll-margin-top
        const line = getDateBarBottom() + 64;
        let next = days[0];
        days.forEach((day)=>{
            if (dayMarker(day).getBoundingClientRect().top <= line) next = day;
        });
        const active = currentDayId ? document.getElementById(currentDayId) : null;
        if (active && active !== next) {
            const activeIndex = Array.from(days).indexOf(active);
            const nextIndex = Array.from(days).indexOf(next);
            if (activeIndex >= 0 && nextIndex < activeIndex && dayMarker(active).getBoundingClientRect().top <= line) return;
        }
        setCurrentDay(next);
    };
    const schedulePickCurrentDay = ()=>{
        if (spyFrame) return;
        spyFrame = requestAnimationFrame(()=>{
            spyFrame = 0;
            pickCurrentDay();
        });
    };
    const updateButtons = ()=>{
        if (!scroller || !prev || !next) return;
        if (!chipsVisible()) {
            prev.hidden = true;
            next.hidden = true;
            return;
        }
        const track = scroller.querySelector(".program-dates-track");
        const list = scroller.querySelector(".program-filters-chips");
        if (!track || !list) {
            prev.hidden = true;
            next.hidden = true;
            return;
        }
        // Right padding is only for aligning the last chip when scrolled; it should
        // not count as overflow when every chip is already visible.
        const leftPad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        const fitsWithoutScroll = list.scrollWidth + leftPad <= scroller.clientWidth + 1;
        if (fitsWithoutScroll) {
            prev.hidden = true;
            next.hidden = true;
            return;
        }
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const atStart = scroller.scrollLeft <= 1;
        const atEnd = scroller.scrollLeft >= maxScroll - 1;
        prev.hidden = atStart;
        next.hidden = atEnd;
    };
    const getScrollAmount = ()=>{
        if (!scroller) return 0;
        const chip = scroller.querySelector(".program-filters-chip");
        const list = scroller.querySelector(".program-filters-chips");
        if (!chip || !list) return scroller.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap) || 0;
        return (chip.offsetWidth + gap) * 3;
    };
    const scrollByChips = (direction)=>{
        if (!scroller) return;
        pauseSpy();
        scroller.scrollBy({
            left: direction * getScrollAmount(),
            behavior: "smooth"
        });
    };
    const finishCalendarTransition = ()=>{
        if (closeTimer !== null) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
        }
        if (toggle?.getAttribute("aria-expanded") === "false" && calendarPanel) calendarPanel.hidden = true;
        measureDatepicker();
        pickCurrentDay();
    };
    const setCalendarExpanded = (expanded)=>{
        if (!toggle || !calendarPanel) return;
        if (closeTimer !== null) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
        }
        if (expanded) {
            calendarPanel.hidden = false;
            requestAnimationFrame(()=>{
                toggle.setAttribute("aria-expanded", "true");
            });
            return;
        }
        toggle.setAttribute("aria-expanded", "false");
        closeTimer = window.setTimeout(finishCalendarTransition, 400);
    };
    const calendarOpen = ()=>toggle?.getAttribute("aria-expanded") === "true";
    if (calendar && toggle && calendarPanel) {
        toggle.addEventListener("click", ()=>{
            setCalendarExpanded(!calendarOpen());
        });
        // It's a drop-down over the schedule: Escape or a click elsewhere closes it.
        calendar.addEventListener("keydown", (event)=>{
            if (event.key !== "Escape" || !calendarOpen()) return;
            setCalendarExpanded(false);
            toggle.focus();
        });
        document.addEventListener("click", (event)=>{
            if (!calendarOpen() || calendar.contains(event.target)) return;
            setCalendarExpanded(false);
        });
    }
    calendarContent?.addEventListener("transitionend", (event)=>{
        if (event.propertyName !== "grid-template-rows") return;
        finishCalendarTransition();
    });
    const jumpToDay = (id)=>{
        const day = document.getElementById(id);
        if (!day) return;
        setCurrentDayById(id);
        measureDatepicker();
        // Smooth-scrolling takes longer than a fixed pause can predict, so keep
        // the spy suppressed until the scroll actually settles (with a timeout
        // fallback for browsers without the `scrollend` event).
        pauseSpy(2000);
        let scrollSettled = false;
        const resumeSpy = ()=>{
            if (scrollSettled) return;
            scrollSettled = true;
            window.removeEventListener("scrollend", resumeSpy);
            ignoreSpyUntil = 0;
        };
        window.addEventListener("scrollend", resumeSpy, {
            once: true
        });
        window.setTimeout(resumeSpy, 1500);
        day.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        if (`#${id}` !== window.location.hash) history.pushState(null, "", `#${id}`);
        day.tabIndex = -1;
        day.focus({
            preventScroll: true
        });
    };
    const onDayLinkClick = (event)=>{
        const link = event.currentTarget;
        const id = decodeURIComponent(link.hash.replace(/^#/, ""));
        if (!document.getElementById(id)) return;
        event.preventDefault();
        if (calendar?.contains(link) && calendarOpen()) setCalendarExpanded(false);
        jumpToDay(id);
    };
    if (nav && scroller && prev && next) {
        prev.addEventListener("click", ()=>scrollByChips(-1));
        next.addEventListener("click", ()=>scrollByChips(1));
        scroller.addEventListener("scroll", updateButtons, {
            passive: true
        });
        scroller.addEventListener("pointerdown", ()=>pauseSpy(1200));
        scroller.addEventListener("wheel", ()=>pauseSpy(1200), {
            passive: true
        });
        nav.querySelectorAll("a[href^='#']").forEach((link)=>{
            link.addEventListener("click", onDayLinkClick);
        });
        new ResizeObserver(()=>{
            updateButtons();
            measureDatepicker();
        }).observe(scroller);
        const track = scroller.querySelector(".program-dates-track");
        if (track) new ResizeObserver(updateButtons).observe(track);
        updateButtons();
    }
    calendar?.querySelectorAll("a[href^='#']").forEach((link)=>{
        link.addEventListener("click", onDayLinkClick);
    });
    if (calendar) new ResizeObserver(measureDatepicker).observe(calendar);
    chipMq.addEventListener("change", ()=>{
        if (chipsVisible() && calendarOpen()) setCalendarExpanded(false);
        updateButtons();
        measureDatepicker();
        pickCurrentDay();
    });
    window.addEventListener("scroll", schedulePickCurrentDay, {
        passive: true
    });
    measureDatepicker();
    pickCurrentDay();
}
function $2e3daaa5d9491b11$var$initDailyShowtimesExpand() {
    document.querySelector(".program-daily")?.addEventListener("click", (event)=>{
        const button = event.target.closest("button.program-daily-more");
        if (!button) return;
        const listId = button.getAttribute("aria-controls");
        const list = listId ? document.getElementById(listId) : button.previousElementSibling;
        if (!(list instanceof HTMLUListElement)) return;
        const extras = list.querySelectorAll(".program-daily-showtime-extra");
        extras.forEach((item)=>{
            item.hidden = false;
        });
        const firstExtra = extras[0];
        if (firstExtra) firstExtra.tabIndex = -1;
        button.remove();
        firstExtra?.focus();
    });
}
$2e3daaa5d9491b11$var$catchUpToToday();
$2e3daaa5d9491b11$var$initProgramDatesScroll();
$2e3daaa5d9491b11$var$initDailyShowtimesExpand();


// The quick-adds (inc/quick-add.php) of the Daily Schedule and the show page,
// which come with the page; spektrix-quick-add.js handles the cart (basket
// quantities, Add to Cart). The − / + buttons step the select, as in the
// Shortlist's Choose Date & Time (and on the Passes page's cards), Get
// Tickets opens reserved seating's pop-up, and How to book on PuSh Pass its
// pop-over.
// The forms with − / + steppers.
const $7e10acb5e4ef7613$var$STEPPED = ".quick-add, .pass-card-form";
// − at none and + at the most are disabled, as in the Shortlist. The cart's
// quantities arrive without a change event (spektrix-quick-add.js sets
// them), so this also runs when the pointer or focus reaches the form.
function $7e10acb5e4ef7613$var$syncSteps(scope) {
    scope.querySelectorAll(".quantity-stepper").forEach((stepper)=>{
        const select = stepper.querySelector("select");
        if (!select) return;
        stepper.querySelectorAll(".quantity-step").forEach((button)=>{
            const step = Number(button.dataset.step || 0);
            button.disabled = step < 0 ? select.selectedIndex <= 0 : select.selectedIndex >= select.options.length - 1;
        });
    });
}
function $7e10acb5e4ef7613$var$stepQuantity(button) {
    const select = button.closest(".quantity-stepper")?.querySelector("select");
    if (!select) return;
    const index = Math.min(select.options.length - 1, Math.max(0, select.selectedIndex + Number(button.dataset.step || 0)));
    if (index === select.selectedIndex) return;
    select.selectedIndex = index;
    select.dispatchEvent(new Event("change", {
        bubbles: true
    }));
    // The button may have just disabled itself: keep focus in the stepper.
    if (button.disabled) select.focus();
}
// Reserved seating's Get Tickets (inc/quick-add.php) opens the pop-up beside
// it: a modal <dialog>, so it sits above everything, the Shortlist's own
// dialog included. While open it waits in the body (the Shortlist keeps its
// copies of the show page's quick-adds in a hidden slot, where a dialog
// can't show), and closing takes it home again. The Shortlist's own Get
// Tickets clicks this one.
const $7e10acb5e4ef7613$var$homes = new WeakMap();
function $7e10acb5e4ef7613$var$openDialog(button) {
    const dialog = button.parentElement?.querySelector(":scope > .quick-add-dialog");
    if (!dialog || dialog.open) return;
    const home = document.createComment("quick-add-dialog");
    dialog.before(home);
    $7e10acb5e4ef7613$var$homes.set(dialog, home);
    document.body.append(dialog);
    dialog.showModal();
}
function $7e10acb5e4ef7613$var$closedDialog(dialog) {
    dialog.querySelectorAll(".success, .info, .error").forEach((message)=>message.remove());
    const home = $7e10acb5e4ef7613$var$homes.get(dialog);
    $7e10acb5e4ef7613$var$homes.delete(dialog);
    if (home?.isConnected) home.replaceWith(dialog);
    else dialog.remove();
}
// How to book on PuSh Pass (inc/quick-add.php's push_pass_help()): the link
// opens a pop-over, in the top layer (the Popover API), so no column, table
// or pop-up clips it, and a click elsewhere or Escape closes it. Cached
// pages, and the Shortlist's copies of show pages, repeat the markup, so
// the ids that join the link (and Close) to the pop-over are given out
// here, on the first click.
let $7e10acb5e4ef7613$var$passHelps = 0;
function $7e10acb5e4ef7613$var$linkPassHelp(link) {
    const tip = link.parentElement?.querySelector(":scope > .pass-help-tip");
    if (!tip || tip.id) return;
    tip.id = `pass-help-${++$7e10acb5e4ef7613$var$passHelps}`;
    link.setAttribute("popovertarget", tip.id);
    const close = tip.querySelector(".pass-help-close");
    close?.setAttribute("popovertarget", tip.id);
    close?.setAttribute("popovertargetaction", "hide");
}
// Over the link's top right corner, a little out from it, inside the
// window; it closes once the link scrolls out of view.
const $7e10acb5e4ef7613$var$openTips = new Set();
function $7e10acb5e4ef7613$var$placePassHelp(tip) {
    const link = tip.parentElement?.querySelector(":scope > .pass-help-link");
    if (!link) return;
    const box = link.getBoundingClientRect();
    const view = document.documentElement;
    if (box.bottom < 0 || box.top > view.clientHeight) {
        tip.hidePopover();
        return;
    }
    const edge = 10;
    const left = Math.max(edge, Math.min(box.right + 8 - tip.offsetWidth, view.clientWidth - edge - tip.offsetWidth));
    const top = Math.max(edge, Math.min(box.top - 8, view.clientHeight - edge - tip.offsetHeight));
    Object.assign(tip.style, {
        inset: "auto",
        margin: "0",
        left: `${left}px`,
        top: `${top}px`
    });
}
function $7e10acb5e4ef7613$var$passHelpToggled(event) {
    const tip = event.target;
    if (!(tip instanceof HTMLElement) || !tip.matches(".pass-help-tip")) return;
    const opening = event.newState === "open";
    // Hidden until placed: "toggle" comes once it's showing.
    if (event.type === "beforetoggle") {
        if (opening) tip.classList.add("is-placing");
        return;
    }
    if (opening) {
        $7e10acb5e4ef7613$var$openTips.add(tip);
        $7e10acb5e4ef7613$var$placePassHelp(tip);
        tip.classList.remove("is-placing");
    } else $7e10acb5e4ef7613$var$openTips.delete(tip);
}
function $7e10acb5e4ef7613$var$initQuickAdd() {
    document.addEventListener("click", (event)=>{
        const target = event.target;
        const button = target?.closest(".quantity-stepper .quantity-step");
        if (button) $7e10acb5e4ef7613$var$stepQuantity(button);
        const opener = target?.closest("[data-quick-add-open]");
        if (opener) $7e10acb5e4ef7613$var$openDialog(opener);
        // Close, or a click on the backdrop (the dialog has no padding, so only
        // the backdrop is the dialog itself).
        const dialog = target?.closest(".quick-add-dialog");
        if (dialog && (target === dialog || target?.closest("[data-quick-add-close]"))) dialog.close();
    });
    // Before the click's own work, which opens the pop-over its id names.
    document.addEventListener("click", (event)=>{
        const link = event.target?.closest?.(".pass-help-link");
        if (link) $7e10acb5e4ef7613$var$linkPassHelp(link);
    }, true);
    // Neither toggle event bubbles.
    document.addEventListener("beforetoggle", $7e10acb5e4ef7613$var$passHelpToggled, true);
    document.addEventListener("toggle", $7e10acb5e4ef7613$var$passHelpToggled, true);
    const replace = ()=>$7e10acb5e4ef7613$var$openTips.forEach($7e10acb5e4ef7613$var$placePassHelp);
    window.addEventListener("scroll", replace, {
        capture: true,
        passive: true
    });
    window.addEventListener("resize", replace);
    // "close" doesn't bubble.
    document.addEventListener("close", (event)=>{
        const dialog = event.target;
        if (dialog instanceof HTMLDialogElement && dialog.matches(".quick-add-dialog")) $7e10acb5e4ef7613$var$closedDialog(dialog);
    }, true);
    [
        "change",
        "focusin",
        "pointerover"
    ].forEach((type)=>{
        document.addEventListener(type, (event)=>{
            const form = event.target?.closest?.($7e10acb5e4ef7613$var$STEPPED);
            if (form) $7e10acb5e4ef7613$var$syncSteps(form);
        });
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $7e10acb5e4ef7613$var$initQuickAdd);
else $7e10acb5e4ef7613$var$initQuickAdd();


// Donation module loaded dynamically when needed
let $6e19b39be3a165d4$var$donationModulePromise = null;

function $6e19b39be3a165d4$var$loadDonationModule() {
    if (!$6e19b39be3a165d4$var$donationModulePromise) $6e19b39be3a165d4$var$donationModulePromise = (parcelRequire("cyZaJ"));
    return $6e19b39be3a165d4$var$donationModulePromise;
}
function $6e19b39be3a165d4$var$waitForDonationModal(callback, maxAttempts = 50) {
    let attempts = 0;
    const check = ()=>{
        attempts++;
        // Check if the modal element exists (React has mounted)
        if (document.querySelector(".modal-donate")) callback();
        else if (attempts < maxAttempts) setTimeout(check, 50);
    };
    check();
}
function $6e19b39be3a165d4$var$openDonationModal(detail) {
    $6e19b39be3a165d4$var$loadDonationModule().then(()=>{
        $6e19b39be3a165d4$var$waitForDonationModal(()=>{
            document.dispatchEvent(new CustomEvent("openDonationModal", {
                detail: detail
            }));
        });
    });
}
function $6e19b39be3a165d4$var$openModalFromHash() {
    if (window.location.hash === "#donate") $6e19b39be3a165d4$var$openDonationModal({
        amount: null,
        triggerElement: null
    });
    if (window.location.hash === "#manage-donation") $6e19b39be3a165d4$var$openDonationModal({
        mode: "manage",
        triggerElement: null
    });
}
// Set up donation button click handlers for lazy loading
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("[data-donation]").forEach((donateButton)=>{
        donateButton.addEventListener("click", (e)=>{
            e.preventDefault();
            $6e19b39be3a165d4$var$openDonationModal({
                amount: donateButton.getAttribute("data-amount") || null,
                triggerElement: donateButton
            });
        });
    });
    // Check for #donate / #manage-donation anchor on page load
    $6e19b39be3a165d4$var$openModalFromHash();
});
// In-page links like <a href="#manage-donation">
window.addEventListener("hashchange", $6e19b39be3a165d4$var$openModalFromHash);
// One-Click Buy (docs/one-click-buy.md): [data-one-click-buy] buttons, and
// #buy, open the pop-up when push-donations turns it on (PUSH_ONE_CLICK_BUY).
let $6e19b39be3a165d4$var$oneClickBuyModulePromise = null;

function $6e19b39be3a165d4$var$openOneClickBuy(triggerElement) {
    if (!window.PUSH_ONE_CLICK_BUY) return false;
    if (!$6e19b39be3a165d4$var$oneClickBuyModulePromise) $6e19b39be3a165d4$var$oneClickBuyModulePromise = (parcelRequire("emPjJ"));
    $6e19b39be3a165d4$var$oneClickBuyModulePromise.then((module)=>module.open(triggerElement));
    return true;
}
// For the quick-add's Quick Buy (spektrix-quick-add.js).
window.openOneClickBuy = $6e19b39be3a165d4$var$openOneClickBuy;
document.addEventListener("click", (e)=>{
    const trigger = e.target.closest("[data-one-click-buy]");
    if (trigger && $6e19b39be3a165d4$var$openOneClickBuy(trigger)) e.preventDefault();
});
if (window.location.hash === "#buy") $6e19b39be3a165d4$var$openOneClickBuy(null);
/*!
 * jQuery Sieve v0.3.0 (2013-04-04)
 * http://rmm5t.github.com/jquery-sieve/
 * Copyright (c) 2013-2017 Ryan McGeary; Licensed MIT
 */ (function() {
    var e;
    e = jQuery, e.fn.sieve = function(t) {
        var n;
        return n = function(e) {
            var t, n, r, o;
            for(o = [], n = 0, r = e.length; r > n; n++)t = e[n], t && o.push(t);
            return o;
        }, this.each(function() {
            var r, o, i;
            return r = e(this), i = e.extend({
                searchInput: null,
                searchTemplate: "<div><label>Search: <input type='text'></label></div>",
                itemSelector: "tbody tr",
                textSelector: null,
                toggle: function(e, t) {
                    return e.toggle(t);
                },
                complete: function() {}
            }, t), i.searchInput || (o = e(i.searchTemplate), i.searchInput = o.find("input"), r.before(o)), i.searchInput.on("keyup.sieve change.sieve", function() {
                var t, o;
                return o = n(e(this).val().toLowerCase().split(/\s+/)), t = r.find(i.itemSelector), t.each(function() {
                    var t, n, r, c, l, a, u;
                    for(n = e(this), i.textSelector ? (t = n.find(i.textSelector), l = t.text().toLowerCase()) : l = n.text().toLowerCase(), r = !0, a = 0, u = o.length; u > a; a++)c = o[a], r && (r = l.indexOf(c) >= 0);
                    return i.toggle(n, r);
                }), i.complete();
            });
        });
    };
}).call(undefined);
jQuery(function($) {
    $(".box-office").on("scroll", function() {
        $(".overflow-hint").addClass("scrolled");
    });
    if ("ontouchstart" in window || window.navigator.msMaxTouchPoints > 0) $("body").addClass("touch-only");
    var cache = Math.floor(new Date().getTime() / 900000); // refresh every 15 mins
    var fuse = null;
    var searchIndex = $.get("https://pushfestival.ca/festival-events/?json&" + cache).then(function(data) {
        fuse = new Fuse(JSON.parse(data), {
            // include: ["score"],
            shouldSort: true,
            threshold: 0.6,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: [
                "text"
            ]
        });
    });
    var showSearch = function() {
        $(".search-modal").addClass("active");
        $(".search-modal").attr("aria-hidden", "false");
        $(".search-modal input").focus();
        $(".push-site--search").prop("tabindex", 0);
        $(".search-close").prop("tabindex", 0);
        if (typeof gtag !== "undefined") gtag("event", "search-activated");
        return false;
    };
    var hideSearch = function() {
        $(".results").removeClass("active");
        $(".push-site--search").prop("tabindex", -1);
        $(".search-close").prop("tabindex", -1);
        $(".search-modal").removeClass("active");
        $(".search-modal").removeClass("working");
        $(".search-modal").attr("aria-hidden", "true");
        $(".search-modal input").prop("value", "");
        $(".search-modal input").blur();
        const searchTrigger = document.querySelector("#searchform .trigger");
        if (searchTrigger) searchTrigger.focus({
            preventScroll: true
        });
        $(".hint").show();
        $(".results").empty();
        return false;
    };
    // Close modal button
    $(".search-modal .search-close").on("click", function(e) {
        e.preventDefault();
        hideSearch();
    });
    // Safari holds onto the page state too well.
    $(window).bind("pageshow", function(event) {
        $(".search-modal").removeClass("working");
    });
    $("#searchform .trigger").on("click", showSearch);
    $(".show_title").focus(function() {
        var $this = $(this);
        $(window).on("keydown", function(e) {
            if (e.keyCode === 13 && $this.is(":focus")) {
                e.preventDefault();
                $this.click();
            }
        });
    });
    $("#searchform .trigger").on("click", showSearch);
    $("#searchform .trigger").on("keydown", function(e) {
        if (e.keyCode === 13) showSearch();
    });
    $(window).on("keydown", function(e) {
        if ($(e.target).closest("shortlist-widget").length) return true;
        // Esc. Before the input check below: the open modal has its search
        // input focused, so Esc never got this far.
        if (e.keyCode === 27 && $(".search-modal").hasClass("active")) {
            hideSearch();
            return true;
        }
        if ($(e.target).is("input, textarea")) return true;
        // A-Z
        if ((e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 65 && e.keyCode <= 90) && e.metaKey === false && e.ctrlKey === false && e.altKey === false) {
            $(".results.active").animate({
                scrollTop: 0
            }, "fast");
            if (typeof gtag !== "undefined") gtag("event", "search-activated-keyboard");
            showSearch();
        }
        // Stop tabbing when search is open
        if (e.keyCode === 9 && $(".search-modal").hasClass("active")) {
            if (!$(".results")[0].classList.contains("active")) {
                e.preventDefault();
                if (document.activeElement.classList.contains("search-close")) document.querySelector(".push-site--search").focus();
                else document.querySelector(".search-close").focus();
            }
        }
        // Refocus on last search item when tab above input
        if (document.activeElement.classList.contains("search-close")) {
            if (e.keyCode === 9 && e.shiftKey) {
                e.preventDefault();
                if (document.querySelector(".search-all-link")) document.querySelector(".search-all-link").focus();
            }
        }
        // Refocus on search input when tabbing past last item
        if (document.activeElement.classList.contains("search-all-link")) {
            if (e.keyCode === 9 && !e.shiftKey) {
                e.preventDefault();
                document.querySelector(".search-close").focus();
            }
        }
        // Up and Down / Tab and Shift+Tab
        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 9 || e.keyCode === 9 && e.shiftKey) {
            $results = $(".results .result");
            var index = $results.index($results.filter(".active")) + (e.keyCode === 38 || e.shiftKey ? -1 : 1);
            if (index >= 0 && index < $results.length) {
                $results.filter(".active").removeClass("active");
                $($results.get(index)).focus().addClass("active");
                return false;
            }
            // if reaches outside .results, remove active class
            if (e.keyCode === 9 && e.shiftKey && index < 0) $results.filter(".active").removeClass("active");
            // if reaches .search-all, prevent default tabbing
            if (e.keyCode === 9 && $(".search-all").hasClass("active")) e.preventDefault();
        }
        // Enter.
        if (e.keyCode === 13 && $(".results .result.active a").length > 0) {
            $(".search-modal").addClass("working");
            // $('.search-modal input').val('');
            setTimeout(function() {
                window.location = $(".results .result.active a").attr("href");
                // If on same page.
                if (window.location.href.replace(/#.*$/, "") === $(".results .result.active a").attr("href").replace(/#.*$/, "")) {
                    $(".results").removeClass("active");
                    $(".search-modal").removeClass("active");
                    $(".push-site--search").prop("tabindex", -1);
                    $(".search-close").prop("tabindex", -1);
                    $(".search-modal").attr("aria-hidden", "true");
                    $(".search-modal").removeClass("working");
                    $(".search-modal input").blur();
                    $("#searchform .trigger").focus();
                }
            }, 1);
        }
    });
    $(".search-modal").on("click", function(e) {
        if ($(e.target).hasClass("search-modal")) hideSearch();
    });
    $(".search-modal .results").on("hover", ".result", function() {
        $(".search-modal .results .active").removeClass("active");
        $(this).addClass("active");
    });
    var previous = "";
    $(".search-modal input").on("keyup", function(e) {
        // Make FF properly clear the search field.
        if (e.keyCode === 27 && $(".search-modal").hasClass("active")) $(".search-modal input").val("");
        $(".results").toggleClass("active", $(".search-modal input").val() !== "");
        if (previous !== $(".search-modal input").val()) {
            $(".hint").hide();
            previous = $(".search-modal input").val();
            $(".results").empty();
            searchIndex.then(function() {
                var results = fuse.search($(".search-modal input").val());
                var groups = {};
                results.forEach(function(result) {
                    if (typeof groups[result.type] === "undefined") groups[result.type] = [];
                    groups[result.type].push(result);
                });
                for(var group in groups)if (groups.hasOwnProperty(group)) {
                    $grouping = $('<div class="grouping"><h2>' + group + "</h2></div>").appendTo(".results");
                    for(var i = 0; i < groups[group].length && i <= 4; i++){
                        var result = groups[group][i];
                        $('<div class="result"><a href="' + result.link + '" aria-label="' + group + " search item " + result.text + '">' + result.text + "</a></div>").appendTo($grouping);
                    }
                }
                $('<div class="result search-all"><a href="/?s=' + previous + '" class="search-all-link"><strong>Search whole site for "' + previous + '"</strong></a></div>').appendTo(".results");
            // $(".results .result").first().addClass("active");
            });
        }
    });
    $(".js-collapsible-faq").click(function() {
        $(this).parents(".collapsible").toggleClass("active");
        return false;
    });
    if ($(".trailer").length > 0) {
        if (!!navigator.userAgent.match(/firefox|msie|trident/i)) $(".trailer, .trailer .internal").css("transition", "none");
        $("body").on("mousemove", function(e) {
            var distance = e.pageX / $(window).width();
            var shiftAmount = distance < 0.5 ? 0 : (distance - 0.5) / 0.5;
            $(".trailer").css("transform", "translateX(-" + shiftAmount * 33 + "vw) rotateZ(" + (30 - shiftAmount * 20) + "deg)");
            $(".trailer .internal").css("transform", "rotateZ(-" + (30 - shiftAmount * 20) + "deg)");
        });
        $(".trailer").hover(function() {
            $(".play-button .clicky").addClass("active");
        }, function() {
            $(".play-button .clicky").removeClass("active");
        });
        $(".trailer, .play-button .clicky").click(function() {
            if ($(window).width() >= 700) {
                $("#home-banner").addClass("play-video");
                $(".video-container .responsive-video").append('<iframe width="560" height="315" src="https://www.youtube.com/embed/VFuH9qRkLqY?autoplay=1&controls=1&modestbranding=1&rel=0" frameborder="0" allowfullscreen></iframe>');
                return false;
            } else return true;
        });
        $(".video-container .clicky").click(function() {
            $("#home-banner").removeClass("play-video");
            $(".video-container .responsive-video iframe").remove();
            return false;
        });
        $(window).on("keyup", function(e) {
            if (e.keyCode === 27 && $("#home-banner").hasClass("play-video")) {
                $("#home-banner").removeClass("play-video");
                $(".video-container .responsive-video iframe").remove();
            }
        });
    }
    $(".tabs").each(function() {
        $tabs = $(this);
        $tabs.find(".tab-switcher .tab").click(function() {
            var index = $tabs.find(".tab-switcher .tab").index($(this));
            $tabs.find(".tab-switcher .tab, .tab-content .tab").removeClass("active");
            $tabs.find(".tab-switcher .tab:nth-child(" + (index + 1) + "), .tab-content .tab:nth-child(" + (index + 1) + ")").addClass("active");
        });
    });
    var sponsorHover = false;
    $(".supporters, .patrons").each(function() {
        var $this = $(this);
        setInterval(function() {
            if (!sponsorHover) $this.find("li:last-child").prependTo($this);
        }, $this.hasClass("supporters") ? 2000 : 2500);
    });
    $(".supporters, .patrons").hover(function() {
        sponsorHover = true;
    }, function() {
        sponsorHover = false;
    });
    /**
   * All events calendar and grid.
   */ $(".day").click(function() {
        // $('.event-grid[data-date="' + $(this).data('date') + '"]').toggleClass('filtered');
        $(this).toggleClass("active");
        $("#" + $(this).data("date")).slideToggle(filterDates);
    });
    $(".js-events-all").click(function() {
        $(".day").addClass("active");
        $(".event-grid").slideDown(filterDates);
        return false;
    });
    $(".js-events-none").click(function() {
        $(".day").removeClass("active");
        $(".event-grid").slideUp(filterDates);
        return false;
    });
    function filterDates() {
        $(".show-count").html($(".event-grid:visible .event-block:not(.filtered)").length);
        $(".no-dates").toggleClass("active", $(".event-grid:visible").length === 0);
    }
    $(".event-grid").click(function() {
        $6e19b39be3a165d4$export$99f06dcbfd164329($(this).attr("id"));
        // Need to be careful about event bubbling, if you click on a link, don't go there yet.
        if (!$(this).hasClass("active")) {
            $(this).addClass("active");
            return false;
        }
    });
    $(".event-grid header").click(function() {
        var $parent1 = $(this).parent(".event-grid");
        // Need to be careful about event bubbling.
        if ($parent1.hasClass("active")) {
            $parent1.removeClass("active");
            return false;
        }
    });
    $(".js-toggle-list").click(function() {
        $(this).parents(".event-grid").addClass("table");
        $(this).parents(".view-toggle").find("a").removeClass("active");
        $(this).addClass("active");
        return false;
    });
    $(".js-toggle-grid").click(function() {
        $(this).parents(".event-grid").removeClass("table");
        $(this).parents(".view-toggle").find("a").removeClass("active");
        $(this).addClass("active");
        return false;
    });
    $(".view-more-btn").on("click", function() {
        $(".hidden-content").slideToggle("fast");
        $(this).toggleClass("active");
        $(this).text($(this).hasClass("active") ? "View Less" : "View More");
        return false;
    });
    // Donation Cards
    var offset = 6;
    var $todayNotches = $(".today-notch");
    var $todayCards = $(".today-card");
    var todayCards = [];
    var $monthlyNotches = $(".monthly-notch");
    var $monthlyCards = $(".monthly-card");
    var monthlyCards = [];
    function Card($elem, currentX, currentY) {
        this.$elem = $elem;
        this.currentX = currentX;
        this.currentY = currentY;
    }
    function addCards($elem, cardArray) {
        $elem.css({
            "z-index": $elem.attr("data-index")
        });
        cardArray.push(new Card($elem, 0, 0));
    }
    function hoverNotches($notchArray, $this, cardArray) {
        var _id = $this.attr("data-index");
        var topY = 0;
        var topX = -480;
        var offsetY = topY;
        var offsetX = topX;
        if ($notchArray === $todayNotches && $(".today-notches").hasClass("active") || $notchArray === $monthlyNotches) {
            $notchArray.eq(_id - 1).addClass("current");
            $notchArray.not($notchArray.eq(_id - 1)).removeClass("current");
            $notchArray.slice(0, _id).addClass("active");
            $notchArray.slice(_id).removeClass("active");
            // set active card to top-left corner
            cardArray[_id - 1].$elem.css({
                transform: "translateX(" + topX + "px)"
            });
            cardArray[_id - 1].currentX = topX;
            // show or shuffle lower card
            cardArray.slice(0, _id - 1).reverse().forEach(function(card) {
                offsetX += offset;
                offsetY += offset;
                card.currentX = offsetX;
                card.currentY = offsetY;
                card.$elem.css({
                    transform: "translate(" + card.currentX + "px," + card.currentY + "px)"
                });
            });
            // remove higher card
            cardArray.slice(_id).forEach(function(card) {
                card.$elem.removeClass("active");
                card.isShowing = false;
                card.currentX -= card.currentX;
                card.currentY -= card.currentY;
                card.$elem.css({
                    transform: "translate(" + card.currentX + "px," + card.currentY + "px)"
                });
            });
        }
    }
    $todayCards.each(function() {
        addCards($(this), todayCards);
    });
    $todayNotches.hover(function() {
        hoverNotches($todayNotches, $(this), todayCards);
    });
    $todayNotches.first().addClass("current active");
    $monthlyCards.each(function() {
        addCards($(this), monthlyCards);
    });
    $monthlyNotches.hover(function() {
        hoverNotches($monthlyNotches, $(this), monthlyCards);
    });
    $monthlyNotches.first().addClass("current active");
    if (monthlyCards.length > 0) monthlyCards[0].$elem.css({
        transform: "translateX(-480px)"
    });
    // Donations Page
    $(".donate-tab").click(function() {
        if ($(this).attr("data-donate") === "today") {
            $(".donate-form-header-title").html("Donate Today");
            window.history.replaceState(null, null, window.location.pathname);
        } else if ($(this).attr("data-donate") === "monthly") {
            $(".donate-form-header-title").html("Donate Monthly");
            window.history.replaceState(null, null, "#" + $(this).attr("data-donate"));
        } else if ($(this).attr("data-donate") === "other") {
            $(".donate-form-header-title").html("Other Ways to Give");
            window.history.replaceState(null, null, "#" + $(this).attr("data-donate"));
        }
        $(this).toggleClass("active");
        $(".donate-tab").not($(this)).removeClass("active");
    });
    var url = window.location.href;
    if (url.indexOf("monthly") >= 0) $('.donate-tab[data-donate="monthly"]').click();
    else if (url.indexOf("other") >= 0) $('.donate-tab[data-donate="other"]').click();
    else $('.donate-tab[data-donate="today"]').click();
    $(".impact-button").click(function() {
        $(".donate-default").animate({
            opacity: 0
        }, 200, function() {
            $(".today-notches").addClass("active");
            $(".today-card").first().css({
                transform: "translateX(-480px)"
            });
            $(".donate-default").hide();
            $(".donate-today-levels").animate({
                opacity: 1
            }, 200);
        });
    });
    // Cookie manager
    if (Cookies.get("hasAcceptedCookieAgreement") !== "true") {
        $("#cookie-warning .button").click(function() {
            $("#cookie-warning").hide();
            Cookies.set("hasAcceptedCookieAgreement", true, {
                expires: 365
            });
        });
        $("#cookie-warning").show();
    }
});
// UPDATE 2020 👇
// Update hash and open tab/accordion on click
jQuery(function($) {
    // TABS
    $(".tab-block .tab").click(function() {
        var $parent1 = $(this).parent();
        var tabTarget = $(this).data("target");
        $parent1.children(".tab").removeClass("active").attr("aria-selected", false);
        $(this).addClass("active").attr("aria-selected", true);
        $parent1.children(".tab-content").removeClass("active").attr("aria-hidden", true);
        $parent1.children('div[data-id="' + tabTarget + '"]').addClass("active").attr("aria-hidden", false);
        $6e19b39be3a165d4$export$99f06dcbfd164329($(this).data("target"));
        return false;
    });
});
jQuery(function($) {
    $(".event-details .push_button").click(function() {
        $("html, body").animate({
            scrollTop: $("#tickets").offset().top - $("header").height() - $(".box-office").height()
        }, 500);
        return false;
    });
});
// If hash is present, open tab/accordion on load and scroll to target
jQuery(function($) {
    var $target;
    var $tabSection;
    var hash = decodeURIComponent(window.location.hash);
    if (hash !== "") {
        hash = hash[hash.length - 1] === "/" ? hash.substring(1, hash.length - 1) : hash.substring(1);
        $target = $('div[data-id="' + hash + '"]').first();
        if ($target.length) {
            // Found a tab or accordion
            var type = $target.hasClass("tab-content") ? "tab" : "accordion";
            if (type === "tab") activateTab($target);
            else activateAccordion($target);
        } else {
            // Either a performance or someone has linked incorrectly
            $target = $("div.event-grid#" + hash).first();
            if ($target.length) activatePerformanceAccordion($target);
        }
    }
    activateDefaultTabs();
    function activateTab($tab1) {
        $tab1.addClass("active");
        $('div[data-target="' + hash + '"]').first().addClass("active").attr("aria-selected", true);
        $tabSection = $tab1.parent(".tab-block");
        $6e19b39be3a165d4$var$scrollToTarget($tab1);
    }
    function activateDefaultTabs() {
        $firstTabs = $(".tab-block").not($tabSection).children(".tab:first-child");
        $firstTabs.each(function() {
            $(this).addClass("active");
            $('div[data-id="' + $(this).data("target") + '"]').addClass("active").attr("aria-hidden", false);
        });
    }
    function activateAccordion($accordion) {
        var targetInsideTab = $accordion.parents(".tab-content").length > 0;
        if (targetInsideTab) {
            $tabSection = $accordion.parents(".tab-block");
            $parent = $accordion.parent(".tab-content");
            $tab = $parent.prev();
            $parent.addClass("active");
            $tab.addClass("active");
        }
        var $button = $('div[data-target="' + hash + '"]').first();
        $button.addClass("active");
        $accordion.slideToggle("fast");
        $6e19b39be3a165d4$var$scrollToTarget($accordion);
    }
    function activatePerformanceAccordion($accordion) {
        if ($accordion.hasClass("active")) $accordion.removeClass("active");
        else $accordion.addClass("active");
        $6e19b39be3a165d4$var$scrollToTarget($accordion);
    }
});
function $6e19b39be3a165d4$var$scrollToTarget($target) {
    jQuery("html, body").animate({
        scrollTop: $target.offset().top - 300
    }, 500);
}
function $6e19b39be3a165d4$export$99f06dcbfd164329($target) {
    if (window.history.pushState) window.history.replaceState(null, null, "#" + $target);
    else window.location.hash = "#" + $target;
}
// 2021 Update
jQuery(function($) {
    var $sbwOuter = $("<div>").css({
        visibility: "hidden",
        width: 100,
        overflow: "scroll"
    }).appendTo("body");
    var scrollBarWidth = 100 - $("<div>").css({
        width: "100%"
    }).appendTo($sbwOuter).outerWidth() + "px";
    $sbwOuter.remove();
    if ($(".filter-delegates").length > 0) $(".page").sieve({
        itemSelector: ".industry-attendee",
        textSelector: "h3",
        searchInput: $(".filter-delegates input")
    });
});
// 2023 Update
jQuery(function($) {
    // TAB keyboard support
    $(".tab-block .tab").on("keydown", function(e) {
        if (e.key === "ArrowRight") {
            e.preventDefault();
            if ($(this).nextAll(".tab:first").length === 0) $(this).siblings(".tab:first").focus();
            else $(this).nextAll(".tab:first").focus();
        }
        if (e.key === "ArrowLeft") {
            e.preventDefault();
            if ($(this).prevAll(".tab:first").length === 0) $(this).siblings(".tab:last").focus();
            else $(this).prevAll(".tab:first").focus();
        }
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).click();
        }
        if (e.key === "ArrowDown" || e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            $(this).nextAll(".tab-content.active").find("[tabindex=0]").first().focus();
        }
    });
});
window.addEventListener("message", function(event) {
    // console.log('SCRIPTS-JS: Received postMessage event:', {
    //   origin: event.origin,
    //   data: event.data ? event.data.substring(0, 50) + '...' : event.data,
    //   type: typeof event.data
    // });
    if (event.origin == 'https://ticketing.purchase.pushfestival.ca' && event.data == 'scrollToTopPlz') window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    if (event.origin == 'https://ticketing.purchase.pushfestival.ca' && event.data.startsWith('scrollToPlz:')) window.scrollTo({
        top: parseFloat(event.data.split(':')[1]),
        behavior: 'smooth'
    });
}, false);

})();
//# sourceMappingURL=scripts.js.map
